import React, { useState, useEffect, useCallback } from "react";
import { adminAPI } from "../../api/api.js";
import TabBridge from "./TabSignalBridge";
import TabPartners from "./TabPartners";
import AdminInvoices from "../../components/admin/AdminInvoices";
import { BannerControl } from "../../components/admin/AdminControls";
import PartnerSignupTab from "../partner/PartnerSignupTab";
import PartnerBrandingTab from "../partner/PartnerBrandingTab";
import PartnerLandingTab from "../partner/PartnerLandingTab";
import PartnerMembersTab from "../partner/PartnerMembersTab";

const C = {
  bg:"var(--bg)", card:"var(--bg-surface)", elevated:"var(--bg-elevated)", border:"var(--border)",
  accent:"var(--accent)", success:"var(--success)", danger:"var(--danger)", warn:"var(--warning)",
  muted:"var(--text-muted)", text:"var(--text-main)", purple:"#c084fc",
};

const fmt    = (n) => n==null?"-":Number(n).toLocaleString();
const fmtPct = (n) => n==null?"-":Number(n).toFixed(1)+"%";
const fmtUSD = (n) => n==null?"-":"$"+Number(n).toFixed(2);
const fmtDate= (s) => s?s.slice(0,10):"-";


// ─── Tab Affiliates ───────────────────────────────────────────────────────────
const TabAffiliates = () => {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [config, setConfig] = useState({mode:1, flat_pct:10});
  const [loading, setLoading] = useState(true);
  const [editCommission, setEditCommission] = useState({});
  const [payoutForm, setPayoutForm] = useState({});
  const [msg, setMsg] = useState("");
  const token = localStorage.getItem("access_token")||localStorage.getItem("token")||"";
  const h = {"Content-Type":"application/json", Authorization:`Bearer ${token}`};

  const load = () => {
    setLoading(true);
    fetch("/api/admin/affiliates", {headers:h})
      .then(r=>r.json())
      .then(d=>{ if(d.ok){ setData(d.data||[]); setSummary(d.summary||{}); setConfig(d.config||{mode:1,flat_pct:10}); }})
      .finally(()=>setLoading(false));
  };
  useEffect(()=>{ load(); },[]);

  const saveConfig = () => {
    fetch("/api/admin/affiliate-config", {method:"PUT", headers:h,
      body: JSON.stringify({mode: config.mode, flat_pct: parseFloat(config.flat_pct)})})
      .then(r=>r.json()).then(d=>{ setMsg(d.message||"Saved"); setTimeout(()=>setMsg(""),3000); load(); });
  };

  const saveCommission = (id) => {
    const val = editCommission[id];
    fetch(`/api/admin/affiliates/${id}/commission`, {method:"PUT", headers:h,
      body: JSON.stringify({custom_pct: val===""||val===null ? null : parseFloat(val)})})
      .then(r=>r.json()).then(d=>{ setMsg(d.message||"Saved"); setTimeout(()=>setMsg(""),3000); load(); });
  };

  const addPayout = (id) => {
    const f = payoutForm[id]||{};
    if(!f.amount) return;
    fetch(`/api/admin/affiliates/${id}/payout`, {method:"POST", headers:h,
      body: JSON.stringify({amount_usd: parseFloat(f.amount), source: f.source||"manual", period: f.period||"", status: f.status||"PENDING"})})
      .then(r=>r.json()).then(d=>{ setMsg(d.message||"Saved"); setTimeout(()=>setMsg(""),3000); load(); });
  };

  if(loading) return <div style={{padding:32,color:C.muted}}>Loading...</div>;

  return (
    <div>
      {msg && <div style={{background:"rgba(29,209,161,0.15)",color:"var(--success)",padding:"8px 16px",borderRadius:8,marginBottom:16,fontSize:13}}>{msg}</div>}

      {/* Summary */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:12,marginBottom:24}}>
        {[
          {l:"Total Affiliates", v:summary.total_affiliates||0, c:C.text},
          {l:"Total Referrals",  v:summary.total_referrals||0,  c:C.accent},
          {l:"Total EUM",        v:`$${Number(summary.total_eum_usd||0).toLocaleString()}`, c:C.accent},
          {l:"Total Paid",       v:`$${Number(summary.total_paid_usd||0).toFixed(2)}`,  c:"var(--success)"},
          {l:"Pending Payout",   v:`$${Number(summary.total_pending_usd||0).toFixed(2)}`, c:C.warn},
        ].map(x=>(
          <div key={x.l} style={{background:C.card2,borderRadius:10,padding:"12px 16px",border:`1px solid ${C.border}`}}>
            <div style={{fontSize:10,color:C.muted,marginBottom:4,textTransform:"uppercase"}}>{x.l}</div>
            <div style={{fontSize:18,fontWeight:800,color:x.c}}>{x.v}</div>
          </div>
        ))}
      </div>

      {/* Config */}
      <div style={{background:C.card2,borderRadius:10,padding:"16px 20px",border:`1px solid ${C.border}`,marginBottom:24}}>
        <div style={{fontSize:12,fontWeight:800,marginBottom:12,textTransform:"uppercase",color:C.muted}}>Affiliate Config</div>
        <div style={{display:"flex",gap:16,alignItems:"flex-end",flexWrap:"wrap"}}>
          <div>
            <div style={{fontSize:11,color:C.muted,marginBottom:4}}>Mode</div>
            <select value={config.mode} onChange={e=>setConfig(c=>({...c,mode:parseFloat(e.target.value)}))}
              style={{background:C.card,border:`1px solid ${C.border}`,color:C.text,padding:"6px 12px",borderRadius:6,fontSize:12}}>
              <option value={1}>Flat Rate</option>
              <option value={0}>Tier System</option>
            </select>
          </div>
          <div>
            <div style={{fontSize:11,color:C.muted,marginBottom:4}}>Flat Commission %</div>
            <input type="number" value={config.flat_pct} min={0} max={100} step={0.5}
              onChange={e=>setConfig(c=>({...c,flat_pct:e.target.value}))}
              style={{background:C.card,border:`1px solid ${C.border}`,color:C.text,padding:"6px 12px",borderRadius:6,fontSize:12,width:80}}/>
          </div>
          <button onClick={saveConfig} style={{padding:"7px 20px",borderRadius:6,border:"none",
            background:C.accent,color:"var(--text-main)",fontSize:12,fontWeight:700,cursor:"pointer"}}>
            Save Config
          </button>
        </div>
      </div>

      {/* Affiliates table */}
      <div style={{background:C.card2,borderRadius:10,border:`1px solid ${C.border}`,overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{borderBottom:`1px solid ${C.border}`}}>
              {["Email","Role","Code","Referrals","EUM","Commission","Paid","Pending","Actions"].map(h=>(
                <th key={h} style={{padding:"10px 12px",textAlign:"left",color:C.muted,fontSize:10,textTransform:"uppercase",fontWeight:600,whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length===0 && (
              <tr><td colSpan={9} style={{padding:32,textAlign:"center",color:C.muted}}>No affiliates yet</td></tr>
            )}
            {data.map((a,i)=>(
              <React.Fragment key={a.id}>
                <tr style={{borderBottom:`1px solid var(--border-subtle)`,verticalAlign:"top"}}>
                  <td style={{padding:"10px 12px"}}>
                    <div style={{fontWeight:700}}>{a.full_name||"—"}</div>
                    <div style={{fontSize:10,color:C.muted,fontFamily:"monospace"}}>{a.email}</div>
                  </td>
                  <td style={{padding:"10px 12px",color:C.muted,textTransform:"capitalize"}}>{a.role}</td>
                  <td style={{padding:"10px 12px",fontFamily:"monospace",fontSize:10,color:C.muted}}>{a.code}</td>
                  <td style={{padding:"10px 12px"}}>
                    <span style={{color:C.accent,fontWeight:700}}>{a.active_referrals}</span>
                    <span style={{color:C.muted}}> / {a.total_referrals}</span>
                  </td>
                  <td style={{padding:"10px 12px",color:C.accent}}>${Number(a.eum_usd).toLocaleString()}</td>
                  <td style={{padding:"10px 12px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:6}}>
                      <input type="number" min={0} max={100} step={0.5}
                        value={editCommission[a.id]!==undefined ? editCommission[a.id] : a.commission_pct}
                        onChange={e=>setEditCommission(p=>({...p,[a.id]:e.target.value}))}
                        style={{width:52,background:C.card,border:`1px solid ${C.border}`,
                          color:a.is_custom?"var(--purple,#a78bfa)":C.text,padding:"3px 6px",borderRadius:4,fontSize:11}}/>
                      <span style={{fontSize:10,color:C.muted}}>%</span>
                      {editCommission[a.id]!==undefined && (
                        <button onClick={()=>saveCommission(a.id)}
                          style={{padding:"2px 8px",borderRadius:4,border:"none",background:C.accent,
                            color:"var(--text-main)",fontSize:10,fontWeight:700,cursor:"pointer"}}>Save</button>
                      )}
                      {a.is_custom && <span style={{fontSize:9,color:"var(--purple,#a78bfa)",fontWeight:700}}>CUSTOM</span>}
                    </div>
                  </td>
                  <td style={{padding:"10px 12px",color:"var(--success)",fontWeight:700}}>${Number(a.total_paid).toFixed(2)}</td>
                  <td style={{padding:"10px 12px",color:C.warn,fontWeight:700}}>${Number(a.total_pending).toFixed(2)}</td>
                  <td style={{padding:"10px 12px"}}>
                    <button onClick={()=>setPayoutForm(p=>({...p,[a.id]:p[a.id]?null:{amount:"",source:"manual",period:"",status:"PENDING"}}))}
                      style={{padding:"3px 10px",borderRadius:4,border:`1px solid ${C.border}`,
                        background:"transparent",color:C.muted,fontSize:10,cursor:"pointer"}}>
                      + Payout
                    </button>
                  </td>
                </tr>
                {payoutForm[a.id] && (
                  <tr style={{borderBottom:`1px solid var(--border-subtle)`,background:"var(--accent-soft)"}}>
                    <td colSpan={9} style={{padding:"10px 12px"}}>
                      <div style={{display:"flex",gap:8,alignItems:"flex-end",flexWrap:"wrap"}}>
                        <div>
                          <div style={{fontSize:10,color:C.muted,marginBottom:3}}>Amount USD</div>
                          <input type="number" placeholder="0.00" value={payoutForm[a.id]?.amount||""}
                            onChange={e=>setPayoutForm(p=>({...p,[a.id]:{...p[a.id],amount:e.target.value}}))}
                            style={{width:80,background:C.card,border:`1px solid ${C.border}`,color:C.text,padding:"4px 8px",borderRadius:4,fontSize:11}}/>
                        </div>
                        <div>
                          <div style={{fontSize:10,color:C.muted,marginBottom:3}}>Source</div>
                          <input placeholder="manual" value={payoutForm[a.id]?.source||""}
                            onChange={e=>setPayoutForm(p=>({...p,[a.id]:{...p[a.id],source:e.target.value}}))}
                            style={{width:100,background:C.card,border:`1px solid ${C.border}`,color:C.text,padding:"4px 8px",borderRadius:4,fontSize:11}}/>
                        </div>
                        <div>
                          <div style={{fontSize:10,color:C.muted,marginBottom:3}}>Period</div>
                          <input placeholder="2026-04" value={payoutForm[a.id]?.period||""}
                            onChange={e=>setPayoutForm(p=>({...p,[a.id]:{...p[a.id],period:e.target.value}}))}
                            style={{width:80,background:C.card,border:`1px solid ${C.border}`,color:C.text,padding:"4px 8px",borderRadius:4,fontSize:11}}/>
                        </div>
                        <div>
                          <div style={{fontSize:10,color:C.muted,marginBottom:3}}>Status</div>
                          <select value={payoutForm[a.id]?.status||"PENDING"}
                            onChange={e=>setPayoutForm(p=>({...p,[a.id]:{...p[a.id],status:e.target.value}}))}
                            style={{background:C.card,border:`1px solid ${C.border}`,color:C.text,padding:"4px 8px",borderRadius:4,fontSize:11}}>
                            <option>PENDING</option>
                            <option>PAID</option>
                          </select>
                        </div>
                        <button onClick={()=>addPayout(a.id)}
                          style={{padding:"5px 14px",borderRadius:4,border:"none",
                            background:"var(--bg-surface)",color:"var(--text-main)",fontSize:11,fontWeight:700,cursor:"pointer"}}>
                          Record Payout
                        </button>
                        <button onClick={()=>setPayoutForm(p=>({...p,[a.id]:null}))}
                          style={{padding:"5px 10px",borderRadius:4,border:`1px solid ${C.border}`,
                            background:"transparent",color:C.muted,fontSize:11,cursor:"pointer"}}>
                          Cancel
                        </button>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};


// ─── Tab Subscriptions ────────────────────────────────────────────────────────
const TIER_COLOR = { trial:"#F59E0B", basic:"#3B82F6", premium:"#22C55E", none:"var(--text-muted)", free:"#A855F7" };
const STATUS_COLOR = { active:"#22C55E", suspended:"var(--danger)", expired:"var(--text-muted)", none:"var(--text-muted)", free:"#A855F7" };
const SUB_LIMIT = { trial:10, basic:10, premium:20, none:0, free:10 };
function fDateSub(iso){ if(!iso) return "—"; return new Date(iso).toLocaleDateString("en-GB",{day:"2-digit",month:"short",year:"numeric"}); }
function daysLeftSub(isoEnd){ if(!isoEnd) return null; return Math.ceil((new Date(isoEnd)-Date.now())/86400000); }

const EditTierForm = ({inv, onSave, onClose}) => {
  const [tier,setTier]=React.useState(inv.tier||"none");
  const [status,setStatus]=React.useState(inv.status||"active");
  const [trialDays,setTrialDays]=React.useState(14);
  const sel={padding:"8px 10px",borderRadius:6,background:C.base,border:`1px solid ${C.border}`,color:C.text,fontSize:13,width:"100%"};
  return (
    <div>
      <div style={{marginBottom:14}}>
        <div style={{fontSize:12,color:C.faint,marginBottom:6}}>TIER</div>
        <select value={tier} onChange={e=>setTier(e.target.value)} style={sel}>
          {["none","trial","basic","premium","free"].map(t=><option key={t} value={t}>{t.charAt(0).toUpperCase()+t.slice(1)}</option>)}
        </select>
        <div style={{fontSize:11,color:C.faint,marginTop:4}}>Basic: 10 max · Premium: 20 max · Trial: 10 max</div>
      </div>
      {tier==="trial"&&<div style={{marginBottom:14}}>
        <div style={{fontSize:12,color:C.faint,marginBottom:6}}>TRIAL DAYS</div>
        <input type="number" value={trialDays} onChange={e=>setTrialDays(Number(e.target.value))} min={1} max={90} style={sel}/>
      </div>}
      <div style={{marginBottom:22}}>
        <div style={{fontSize:12,color:C.faint,marginBottom:6}}>STATUS</div>
        <select value={status} onChange={e=>setStatus(e.target.value)} style={sel}>
          {["active","suspended","expired","free"].map(s=><option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
        </select>
      </div>
      <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
        <button onClick={onClose} style={{padding:"7px 16px",borderRadius:6,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,cursor:"pointer",fontSize:13}}>Cancel</button>
        <button onClick={()=>onSave({tier,status,trial_days:trialDays})} style={{padding:"7px 16px",borderRadius:6,border:"none",background:C.accent,color:"#fff",cursor:"pointer",fontSize:13,fontWeight:600}}>Save</button>
      </div>
    </div>
  );
};

const InvoiceCapitalSub = ({inv, token, onClose}) => {
  const BASE=import.meta.env.VITE_API_URL||"";
  const [invoices,setInvoices]=React.useState([]);
  const [loading,setLoading]=React.useState(true);
  React.useEffect(()=>{
    fetch(`${BASE}/api/admin/subscriptions/${inv.id}/invoices`,{headers:{Authorization:`Bearer ${token}`}})
      .then(r=>r.json()).then(d=>setInvoices(d.invoices||d||[])).catch(()=>{}).finally(()=>setLoading(false));
  },[inv.id]);
  const act=async(invoiceId,action)=>{
    if(!confirm(`${action} this invoice?`)) return;
    await fetch(`${BASE}/api/admin/invoices/${invoiceId}/${action}`,{method:"POST",headers:{Authorization:`Bearer ${token}`}});
    setInvoices(prev=>prev.map(i=>i.id===invoiceId?{...i,status:action==="mark-paid"?"PAID":"WAIVED"}:i));
  };
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}} onClick={onClose}>
      <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,padding:24,width:680,maxWidth:"95vw",maxHeight:"80vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div>
            <div style={{color:C.text,fontWeight:600,fontSize:15}}>Invoices — {inv.name}</div>
            <div style={{color:C.muted,fontSize:12}}>{inv.email}</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.muted,fontSize:20,cursor:"pointer"}}>&times;</button>
        </div>
        {loading?<div style={{textAlign:"center",padding:32,color:C.muted}}>Loading...</div>
        :invoices.length===0?<div style={{textAlign:"center",padding:32,color:C.muted}}>No invoices yet.</div>
        :<table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
          <thead><tr style={{borderBottom:`1px solid ${C.border}`}}>
            {["Type","Amount","Description","Due Date","Status","Actions"].map(h=>(
              <th key={h} style={{textAlign:"left",padding:"6px 10px",color:C.faint,fontWeight:500}}>{h}</th>
            ))}
          </tr></thead>
          <tbody>{invoices.map(iv=>(
            <tr key={iv.id} style={{borderBottom:`1px solid ${C.border}`}}>
              <td style={{padding:"8px 10px",color:C.muted}}>{iv.type}</td>
              <td style={{padding:"8px 10px",color:C.text,fontWeight:500}}>${Number(iv.amount||0).toFixed(2)}</td>
              <td style={{padding:"8px 10px",color:C.muted,maxWidth:160}}>{iv.description||"—"}</td>
              <td style={{padding:"8px 10px",color:C.muted,whiteSpace:"nowrap"}}>{fDateSub(iv.due_date)}</td>
              <td style={{padding:"8px 10px"}}>
                <span style={{fontSize:11,fontWeight:600,textTransform:"uppercase",color:iv.status==="PAID"||iv.status==="WAIVED"?"#22C55E":iv.status==="OVERDUE"?"var(--danger)":"#F59E0B"}}>{iv.status}</span>
              </td>
              <td style={{padding:"8px 10px"}}>
                {(iv.status==="PENDING"||iv.status==="OVERDUE")&&<div style={{display:"flex",gap:6}}>
                  <button onClick={()=>act(iv.id,"mark-paid")} style={{fontSize:11,padding:"3px 8px",borderRadius:4,border:"1px solid #22C55E",background:"transparent",color:"#22C55E",cursor:"pointer"}}>Mark Paid</button>
                  <button onClick={()=>act(iv.id,"waive")} style={{fontSize:11,padding:"3px 8px",borderRadius:4,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,cursor:"pointer"}}>Waive</button>
                </div>}
              </td>
            </tr>
          ))}</tbody>
        </table>}
      </div>
    </div>
  );
};

const TabSubscriptions = ({token}) => {
  const BASE=import.meta.env.VITE_API_URL||"";
  const [investors,setInvestors]=React.useState([]);
  const [stats,setStats]=React.useState({});
  const [loading,setLoading]=React.useState(true);
  const [search,setSearch]=React.useState("");
  const [filterTier,setFilterTier]=React.useState("all");
  const [editTarget,setEditTarget]=React.useState(null);
  const [invoiceTarget,setInvoiceTarget]=React.useState(null);

  const load=React.useCallback(()=>{
    setLoading(true);
    Promise.all([
      fetch(`${BASE}/api/admin/subscriptions`,{headers:{Authorization:`Bearer ${token}`}}).then(r=>r.json()),
      fetch(`${BASE}/api/admin/subscription-stats`,{headers:{Authorization:`Bearer ${token}`}}).then(r=>r.json()),
    ]).then(([s,st])=>{setInvestors(s.subscriptions||[]);setStats(st.stats||{});}).catch(()=>{}).finally(()=>setLoading(false));
  },[token]);

  React.useEffect(()=>{load();},[load]);

  const handleUpdate=async(userId,body)=>{
    const res=await fetch(`${BASE}/api/admin/subscriptions/${userId}`,{method:"PUT",headers:{Authorization:`Bearer ${token}`,"Content-Type":"application/json"},body:JSON.stringify(body)});
    if(res.ok) load(); else alert("Failed to update");
  };

  const filtered=investors.filter(inv=>{
    const ms=inv.name?.toLowerCase().includes(search.toLowerCase())||inv.email?.toLowerCase().includes(search.toLowerCase());
    const mt=filterTier==="all"||inv.tier===filterTier;
    return ms&&mt;
  });

  return (
    <div style={{padding:"0 0 40px"}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:12,marginBottom:24}}>
        {[
          {label:"Total Investors",value:stats.total||0,color:C.text},
          {label:"Trial",value:stats.trial||0,color:TIER_COLOR.trial},
          {label:"Basic",value:stats.basic||0,color:TIER_COLOR.basic},
          {label:"Premium",value:stats.premium||0,color:TIER_COLOR.premium},
          {label:"Free",value:stats.free||0,color:TIER_COLOR.free},
          {label:"No Plan",value:stats.none||0,color:C.muted},
        ].map(s=>(
          <div key={s.label} style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:10,padding:"14px 18px"}}>
            <div style={{fontSize:22,fontWeight:700,color:s.color}}>{s.value}</div>
            <div style={{fontSize:12,color:C.faint,marginTop:2}}>{s.label}</div>
          </div>
        ))}
      </div>
      <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
        <input placeholder="Search name or email..." value={search} onChange={e=>setSearch(e.target.value)}
          style={{padding:"7px 12px",borderRadius:6,border:`1px solid ${C.border}`,background:C.base,color:C.text,fontSize:13,width:240}}/>
        <select value={filterTier} onChange={e=>setFilterTier(e.target.value)}
          style={{padding:"7px 12px",borderRadius:6,border:`1px solid ${C.border}`,background:C.base,color:C.text,fontSize:13}}>
          <option value="all">All Tiers</option>
          {["none","trial","basic","premium","free"].map(t=><option key={t} value={t}>{t.charAt(0).toUpperCase()+t.slice(1)}</option>)}
        </select>
        <span style={{marginLeft:"auto",fontSize:12,color:C.faint}}>{filtered.length} investors</span>
      </div>
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
          <thead>
            <tr style={{borderBottom:`1px solid ${C.border}`}}>
              {["Investor","Tier","Status","Trial / Billing","Subs Limit","Actions"].map(h=>(
                <th key={h} style={{textAlign:"left",padding:"8px 12px",color:C.faint,fontWeight:500,whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading?<tr><td colSpan={6} style={{textAlign:"center",padding:40,color:C.muted}}>Loading...</td></tr>
            :filtered.length===0?<tr><td colSpan={6} style={{textAlign:"center",padding:40,color:C.muted}}>No investors found</td></tr>
            :filtered.map(inv=>{
              const limit=SUB_LIMIT[inv.tier]||0;
              const dl=daysLeftSub(inv.trial_ends_at);
              return (
                <tr key={inv.id} style={{borderBottom:`1px solid ${C.border}`}}>
                  <td style={{padding:"10px 12px"}}>
                    <div style={{color:C.text,fontWeight:500}}>{inv.name}</div>
                    <div style={{color:C.faint,fontSize:11}}>{inv.email}</div>
                  </td>
                  <td style={{padding:"10px 12px"}}>
                    <span style={{display:"inline-block",padding:"2px 8px",borderRadius:4,fontSize:11,fontWeight:600,textTransform:"uppercase",color:TIER_COLOR[inv.tier]||C.faint,border:`1px solid ${TIER_COLOR[inv.tier]||C.border}`}}>
                      {inv.tier||"none"}
                    </span>
                  </td>
                  <td style={{padding:"10px 12px"}}>
                    <span style={{fontSize:12,color:STATUS_COLOR[inv.status]||C.faint}}>{inv.status||"—"}</span>
                  </td>
                  <td style={{padding:"10px 12px",color:C.muted,whiteSpace:"nowrap"}}>
                    {inv.tier==="trial"&&inv.trial_ends_at?(
                      <span>Ends {fDateSub(inv.trial_ends_at)}
                        {dl!=null&&<span style={{marginLeft:6,fontSize:11,color:dl<=3?"var(--danger)":"#F59E0B"}}>({dl}d left)</span>}
                      </span>
                    ):(inv.tier==="basic"||inv.tier==="premium")&&inv.next_billing_date?(
                      <span>Next bill {fDateSub(inv.next_billing_date)}</span>
                    ):"—"}
                  </td>
                  <td style={{padding:"10px 12px"}}>
                    {limit>0?(
                      <div>
                        <span style={{color:C.text,fontWeight:500,fontSize:13}}>{limit}</span>
                        <span style={{color:C.faint,fontSize:12}}> max</span>
                        <div style={{fontSize:10,color:C.faint,marginTop:1}}>
                          {inv.tier==="basic"?"Basic · 10 subs":inv.tier==="premium"?"Premium · 20 subs":"Trial · 10 subs"}
                        </div>
                      </div>
                    ):<span style={{color:C.faint}}>—</span>}
                  </td>
                  <td style={{padding:"10px 12px"}}>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                      <button onClick={()=>setEditTarget(inv)} style={{fontSize:11,padding:"3px 10px",borderRadius:4,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,cursor:"pointer"}}>Set Tier</button>
                      <button onClick={()=>handleUpdate(inv.id,{tier:"trial",trial_days:14})} style={{fontSize:11,padding:"3px 10px",borderRadius:4,border:`1px solid ${TIER_COLOR.trial}`,background:"transparent",color:TIER_COLOR.trial,cursor:"pointer"}}>Reset Trial</button>
                      <button onClick={()=>setInvoiceTarget(inv)} style={{fontSize:11,padding:"3px 10px",borderRadius:4,border:`1px solid ${C.border}`,background:"transparent",color:C.faint,cursor:"pointer"}}>Invoices</button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {editTarget&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}} onClick={()=>setEditTarget(null)}>
          <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,padding:28,width:380,maxWidth:"95vw"}} onClick={e=>e.stopPropagation()}>
            <div style={{fontWeight:600,fontSize:15,color:C.text,marginBottom:4}}>Set Subscription Tier</div>
            <div style={{color:C.muted,fontSize:12,marginBottom:20}}>{editTarget.name} · {editTarget.email}</div>
            <EditTierForm inv={editTarget} onSave={body=>{handleUpdate(editTarget.id,body);setEditTarget(null);}} onClose={()=>setEditTarget(null)}/>
          </div>
        </div>
      )}
      {invoiceTarget&&<InvoiceCapitalSub inv={invoiceTarget} token={token} onClose={()=>setInvoiceTarget(null)}/>}
    </div>
  );
};


// ─── Tab Payments ─────────────────────────────────────────────────────────────
const TabPayments = ({token}) => {
  const BASE = import.meta.env.VITE_API_URL||"";
  const [requests, setRequests] = React.useState([]);
  const [loading, setLoading]   = React.useState(true);
  const [filter, setFilter]     = React.useState("pending");
  const [note, setNote]         = React.useState({});
  const [saving, setSaving]     = React.useState(null);
  const [toast, setToast]       = React.useState(null);

  const showMsg = (msg, ok=true) => { setToast({msg,ok}); setTimeout(()=>setToast(null),4000); };

  const load = React.useCallback(()=>{
    setLoading(true);
    const q = filter==="all" ? "" : `?status=${filter}`;
    fetch(`${BASE}/api/admin/payment-requests${q}`, {headers:{Authorization:`Bearer ${token}`}})
      .then(r=>r.json())
      .then(d=>setRequests(d.requests||[]))
      .catch(()=>{})
      .finally(()=>setLoading(false));
  },[token, filter]);

  React.useEffect(()=>{ load(); },[load]);

  const confirm = async (id, action) => {
    setSaving(id+action);
    const r = await fetch(`${BASE}/api/admin/payment-requests/${id}/confirm`, {
      method:"PUT",
      headers:{Authorization:`Bearer ${token}`,"Content-Type":"application/json"},
      body: JSON.stringify({ action, adminNote: note[id]||"" })
    }).then(r=>r.json());
    setSaving(null);
    if(r.ok) { showMsg(action==="approve"?"Payment approved — tier upgraded!":"Payment rejected"); load(); }
    else showMsg(r.error||"Failed", false);
  };

  const statusColor = {pending:"#F59E0B", verifying:"#3B82F6", approved:"#10B981", rejected:"var(--danger)", cancelled:"#6B7280"};
  const methodLabel = (m) => ({bank_transfer:"Bank Transfer", crypto_usdt:"Crypto USDT"}[m]||m);

  return (
    <div style={{padding:"0 0 40px"}}>
      {toast && <div style={{position:"fixed",bottom:24,right:24,zIndex:2000,
        background:toast.ok?"#10B981":"var(--danger)",color:"#fff",
        padding:"12px 20px",borderRadius:8,fontWeight:600,fontSize:13}}>{toast.msg}</div>}

      {/* Filter */}
      <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
        {["pending","verifying","approved","rejected","all"].map(s=>(
          <button key={s} onClick={()=>setFilter(s)}
            style={{padding:"6px 14px",borderRadius:20,fontSize:12,fontWeight:600,cursor:"pointer",
              border:`1px solid ${filter===s?(statusColor[s]||C.accent):C.border}`,
              background:filter===s?`${statusColor[s]||C.accent}22`:"transparent",
              color:filter===s?(statusColor[s]||C.accent):C.muted,textTransform:"capitalize"}}>
            {s}
          </button>
        ))}
        <span style={{marginLeft:"auto",fontSize:12,color:C.faint}}>{requests.length} requests</span>
      </div>

      {/* Table */}
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
          <thead>
            <tr style={{borderBottom:`1px solid ${C.border}`}}>
              {["Date","Investor","Plan","Cycle","Amount","Method","Status","Admin Note","Actions"].map(h=>(
                <th key={h} style={{textAlign:"left",padding:"8px 12px",color:C.faint,fontWeight:500,whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={9} style={{textAlign:"center",padding:40,color:C.muted}}>Loading...</td></tr>
            ) : requests.length===0 ? (
              <tr><td colSpan={9} style={{textAlign:"center",padding:40,color:C.muted}}>No payment requests found</td></tr>
            ) : requests.map(r=>(
              <tr key={r.id} style={{borderBottom:`1px solid ${C.border}`}}>
                <td style={{padding:"10px 12px",color:C.muted,whiteSpace:"nowrap",fontSize:11}}>{r.createdAt}</td>
                <td style={{padding:"10px 12px"}}>
                  <div style={{color:C.text,fontWeight:500,fontSize:12}}>{r.name||r.email}</div>
                  <div style={{color:C.faint,fontSize:11}}>{r.email}</div>
                </td>
                <td style={{padding:"10px 12px"}}>
                  <span style={{fontSize:12,fontWeight:700,textTransform:"capitalize",
                    color:r.tier==="premium"?"var(--purple,#a78bfa)":C.accent}}>{r.tier}</span>
                </td>
                <td style={{padding:"10px 12px",fontSize:12,color:C.muted,textTransform:"capitalize"}}>{r.cycle}</td>
                <td style={{padding:"10px 12px",fontSize:13,fontWeight:700,color:C.text}}>${Number(r.amountUsd).toFixed(2)}</td>
                <td style={{padding:"10px 12px",fontSize:12,color:C.muted}}>{methodLabel(r.method)}</td>
                <td style={{padding:"10px 12px"}}>
                  <span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:10,textTransform:"capitalize",
                    color:statusColor[r.status]||C.muted,
                    border:`1px solid ${statusColor[r.status]||C.border}`,
                    background:`${statusColor[r.status]||C.muted}22`}}>
                    {r.status}
                  </span>
                </td>
                <td style={{padding:"10px 12px",minWidth:180}}>
                  {(r.status==="pending"||r.status==="verifying") ? (
                    <input value={note[r.id]||""} onChange={e=>setNote(n=>({...n,[r.id]:e.target.value}))}
                      placeholder="Add note..."
                      style={{width:"100%",padding:"5px 8px",background:C.base,border:`1px solid ${C.border}`,
                        borderRadius:6,color:C.text,fontSize:12,outline:"none"}}/>
                  ) : (
                    <span style={{fontSize:11,color:C.faint}}>{r.adminNote||"—"}</span>
                  )}
                </td>
                <td style={{padding:"10px 12px"}}>
                  {r.status==="pending" ? (
                    <div style={{display:"flex",gap:6}}>
                      <button disabled={saving===r.id+"approve"}
                        onClick={()=>confirm(r.id,"approve")}
                        style={{fontSize:11,padding:"4px 12px",borderRadius:6,cursor:"pointer",fontWeight:700,
                          border:"1px solid #10B981",background:"#10B98122",color:"#10B981"}}>
                        {saving===r.id+"approve"?"...":"Approve"}
                      </button>
                      <button disabled={saving===r.id+"reject"}
                        onClick={()=>confirm(r.id,"reject")}
                        style={{fontSize:11,padding:"4px 12px",borderRadius:6,cursor:"pointer",fontWeight:700,
                          border:"1px solid #EF4444",background:"#EF444422",color:"var(--danger)"}}>
                        {saving===r.id+"reject"?"...":"Reject"}
                      </button>
                    </div>
                  ) : (
                    <span style={{fontSize:11,color:C.faint}}>—</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// ─── Tab Withdrawals ──────────────────────────────────────────────────────────
const TabWithdrawals = ({token}) => {
  const [withdrawals, setWithdrawals] = React.useState([]);
  const [loading, setLoading]         = React.useState(true);
  const [filter, setFilter]           = React.useState("pending");
  const [roleFilter, setRoleFilter]   = React.useState("all");
  const [note, setNote]               = React.useState({});
  const [saving, setSaving]           = React.useState(null);
  const [toast, setToast]             = React.useState(null);

  const showMsg = (msg, ok=true) => { setToast({msg,ok}); setTimeout(()=>setToast(null),4000); };

  const load = React.useCallback(()=>{
    setLoading(true);
    const params = new URLSearchParams();
    if(filter !== "all") params.set("status", filter);
    if(roleFilter !== "all") params.set("role", roleFilter);
    fetch(`/api/admin/withdrawals?${params}`, {headers:{Authorization:`Bearer ${token}`}})
      .then(r=>r.json())
      .then(d=>setWithdrawals(d.withdrawals||[]))
      .catch(()=>{})
      .finally(()=>setLoading(false));
  },[token, filter, roleFilter]);

  React.useEffect(()=>{ load(); },[load]);

  const action = async (id, act) => {
    setSaving(id+act);
    const r = await fetch(`/api/admin/withdrawals/${id}/${act}`, {
      method:"POST",
      headers:{Authorization:`Bearer ${token}`,"Content-Type":"application/json"},
      body: JSON.stringify({ adminNote: note[id]||"" })
    }).then(r=>r.json());
    setSaving(null);
    if(r.ok) { showMsg(r.message||"Done"); load(); }
    else showMsg(r.error||"Failed", false);
  };

  const statusColor = {pending:"#F59E0B", approved:"#3B82F6", paid:"#10B981", rejected:"var(--danger)"};
  const roleColor   = {trader:"var(--accent)", analyst:"#a78bfa"};

  return (
    <div style={{padding:"0 0 40px"}}>
      {toast && <div style={{position:"fixed",bottom:24,right:24,zIndex:2000,
        background:toast.ok?"#10B981":"var(--danger)",color:"#fff",
        padding:"12px 20px",borderRadius:8,fontWeight:600,fontSize:13}}>{toast.msg}</div>}

      <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
        {["pending","approved","paid","rejected","all"].map(s=>(
          <button key={s} onClick={()=>setFilter(s)}
            style={{padding:"6px 14px",borderRadius:20,fontSize:12,fontWeight:600,cursor:"pointer",
              border:`1px solid ${filter===s?(statusColor[s]||C.accent):C.border}`,
              background:filter===s?`${statusColor[s]||C.accent}22`:"transparent",
              color:filter===s?(statusColor[s]||C.accent):C.muted,textTransform:"capitalize"}}>
            {s}
          </button>
        ))}
        <div style={{width:1,height:20,background:C.border,margin:"0 4px"}}/>
        {["all","trader","analyst"].map(r=>(
          <button key={r} onClick={()=>setRoleFilter(r)}
            style={{padding:"6px 14px",borderRadius:20,fontSize:12,fontWeight:600,cursor:"pointer",
              border:`1px solid ${roleFilter===r?(roleColor[r]||C.accent):C.border}`,
              background:roleFilter===r?`${roleColor[r]||C.accent}22`:"transparent",
              color:roleFilter===r?(roleColor[r]||C.accent):C.muted,textTransform:"capitalize"}}>
            {r}
          </button>
        ))}
        <span style={{marginLeft:"auto",fontSize:12,color:C.faint}}>{withdrawals.length} requests</span>
      </div>

      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
          <thead>
            <tr style={{borderBottom:`1px solid ${C.border}`}}>
              {["Date","User","Role","Amount","Method","Notes","Status","Admin Note","Actions"].map(h=>(
                <th key={h} style={{textAlign:"left",padding:"8px 12px",color:C.faint,fontWeight:500,whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={9} style={{textAlign:"center",padding:40,color:C.muted}}>Loading...</td></tr>
            ) : withdrawals.length===0 ? (
              <tr><td colSpan={9} style={{textAlign:"center",padding:40,color:C.muted}}>No withdrawal requests found</td></tr>
            ) : withdrawals.map(w=>(
              <tr key={w.id} style={{borderBottom:`1px solid ${C.border}`}}>
                <td style={{padding:"10px 12px",color:C.muted,whiteSpace:"nowrap",fontSize:11}}>{w.requested_at}</td>
                <td style={{padding:"10px 12px"}}>
                  <div style={{color:C.text,fontWeight:500,fontSize:12}}>{w.user_name}</div>
                  <div style={{color:C.faint,fontSize:11}}>{w.email}</div>
                </td>
                <td style={{padding:"10px 12px"}}>
                  <span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:10,textTransform:"capitalize",
                    color:roleColor[w.role]||C.muted,border:`1px solid ${roleColor[w.role]||C.border}`,
                    background:`${roleColor[w.role]||C.muted}22`}}>{w.role}</span>
                </td>
                <td style={{padding:"10px 12px",fontSize:13,fontWeight:700,color:C.text}}>${Number(w.amount).toFixed(2)}</td>
                <td style={{padding:"10px 12px",fontSize:12,color:C.muted,textTransform:"capitalize"}}>{w.method?.replace("_"," ")}</td>
                <td style={{padding:"10px 12px",fontSize:11,color:C.faint,maxWidth:160}}>{w.notes||"—"}</td>
                <td style={{padding:"10px 12px"}}>
                  <span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:10,textTransform:"capitalize",
                    color:statusColor[w.status]||C.muted,border:`1px solid ${statusColor[w.status]||C.border}`,
                    background:`${statusColor[w.status]||C.muted}22`}}>{w.status}</span>
                </td>
                <td style={{padding:"10px 12px",minWidth:160}}>
                  {(w.status==="pending"||w.status==="approved") ? (
                    <input value={note[w.id]||""} onChange={e=>setNote(n=>({...n,[w.id]:e.target.value}))}
                      placeholder="Admin note..."
                      style={{width:"100%",padding:"5px 8px",background:C.base,border:`1px solid ${C.border}`,
                        borderRadius:6,color:C.text,fontSize:12,outline:"none"}}/>
                  ) : (
                    <span style={{fontSize:11,color:C.faint}}>{w.notes||"—"}</span>
                  )}
                </td>
                <td style={{padding:"10px 12px"}}>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                    {w.status==="pending" && <>
                      <button disabled={saving===w.id+"approve"} onClick={()=>action(w.id,"approve")}
                        style={{fontSize:11,padding:"4px 10px",borderRadius:6,cursor:"pointer",fontWeight:700,
                          border:"1px solid #3B82F6",background:"#3B82F622",color:"#3B82F6"}}>
                        {saving===w.id+"approve"?"...":"Approve"}
                      </button>
                      <button disabled={saving===w.id+"reject"} onClick={()=>action(w.id,"reject")}
                        style={{fontSize:11,padding:"4px 10px",borderRadius:6,cursor:"pointer",fontWeight:700,
                          border:"1px solid #EF4444",background:"#EF444422",color:"var(--danger)"}}>
                        {saving===w.id+"reject"?"...":"Reject"}
                      </button>
                    </>}
                    {w.status==="approved" && <>
                      <button disabled={saving===w.id+"mark-paid"} onClick={()=>action(w.id,"mark-paid")}
                        style={{fontSize:11,padding:"4px 10px",borderRadius:6,cursor:"pointer",fontWeight:700,
                          border:"1px solid #10B981",background:"#10B98122",color:"#10B981"}}>
                        {saving===w.id+"mark-paid"?"...":"Mark Paid"}
                      </button>
                      <button disabled={saving===w.id+"reject"} onClick={()=>action(w.id,"reject")}
                        style={{fontSize:11,padding:"4px 10px",borderRadius:6,cursor:"pointer",fontWeight:700,
                          border:"1px solid #EF4444",background:"#EF444422",color:"var(--danger)"}}>
                        {saving===w.id+"reject"?"...":"Reject"}
                      </button>
                    </>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const TABS = ["Overview","Users","Accounts","Signal Sets","Brokers","Cashflow","User Growth","Fee Report","Fee Overrides","Platform Config","Audit Logs","Affiliates","Subscriptions","Payments","Withdrawals","Invoices ","Banner","Bridge","Multi-Fee","Partners"];

const rolePill = (role) => {
  const map={trader:C.success,analyst:C.warn,investor:C.accent,admin:C.purple,mt4:C.accent,mt5:C.success};
  const bg ={trader:C.success+"22",analyst:C.warn+"22",investor:C.accent+"22",admin:C.purple+"22",mt4:C.accent+"22",mt5:C.success+"22"};
  return <span style={{background:bg[role]||"#fff1",color:map[role]||C.muted,fontSize:11,padding:"2px 8px",borderRadius:6,fontWeight:600}}>{role}</span>;
};

const statusPill = (s) => {
  const active = s==="ACTIVE"||s==="active"||s==="Active";
  const cancelled = s==="CANCELLED"||s==="cancelled";
  const color = active?C.success:cancelled?C.danger:C.warn;
  return <span style={{background:color+"22",color,fontSize:11,padding:"2px 8px",borderRadius:6,fontWeight:600}}>{s}</span>;
};

const Th=({children,w})=><th style={{textAlign:"left",padding:"9px 14px",fontSize:11,color:C.muted,fontWeight:600,letterSpacing:"0.05em",borderBottom:`1px solid ${C.border}`,whiteSpace:"nowrap",textTransform:"uppercase",width:w}}>{children}</th>;
const Td=({children,style})=><td style={{padding:"10px 14px",fontSize:12,color:C.text,borderBottom:`1px solid ${C.border}`,...style}}>{children}</td>;

const MetricCard=({label,value,sub,color,small})=>(
  <div style={{background:C.elevated,border:`1px solid ${C.border}`,borderRadius:10,padding:"16px 18px"}}>
    <div style={{fontSize:11,color:C.muted,fontWeight:700,letterSpacing:"0.05em",marginBottom:6,textTransform:"uppercase"}}>{label}</div>
    <div style={{fontSize:small?18:24,fontWeight:800,color:color||C.text,lineHeight:1.1}}>{value}</div>
    {sub&&<div style={{fontSize:11,color:C.muted,marginTop:4}}>{sub}</div>}
  </div>
);

const Section=({title,action,children})=>(
  <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,marginBottom:16,overflow:"hidden"}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 16px",borderBottom:`1px solid ${C.border}`}}>
      <span style={{fontSize:13,fontWeight:600,color:C.text}}>{title}</span>
      {action}
    </div>
    {children}
  </div>
);

const Btn=({onClick,children,danger,small,primary,disabled})=>(
  <button onClick={onClick} disabled={disabled} style={{fontSize:small?11:12,padding:small?"3px 10px":"6px 14px",borderRadius:6,
    border:`1px solid ${danger?C.danger:primary?"transparent":C.border}`,
    background:primary?"var(--accent)":danger?C.danger+"22":"transparent",
    color:danger?C.danger:primary?"#fff":C.text,cursor:disabled?"not-allowed":"pointer",fontWeight:500,opacity:disabled?0.5:1}}>{children}</button>
);

const Capital=({title,onClose,children})=>(
  <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center"}}>
    <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:"24px",width:500,maxWidth:"95vw"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <span style={{fontWeight:700,fontSize:15,color:C.text}}>{title}</span>
        <button onClick={onClose} style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:C.muted}}>×</button>
      </div>
      {children}
    </div>
  </div>
);

const Input=({label,value,onChange,type="text",placeholder})=>(
  <div style={{marginBottom:12}}>
    <label style={{fontSize:11,color:C.muted,display:"block",marginBottom:4,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.04em"}}>{label}</label>
    <input type={type} value={value} onChange={onChange} placeholder={placeholder}
      style={{width:"100%",padding:"8px 10px",border:`1px solid ${C.border}`,borderRadius:6,fontSize:13,boxSizing:"border-box",background:C.elevated,color:C.text}}/>
  </div>
);

// ─── Paginated Table ──────────────────────────────────────────────────────────
const PagedTable=({data,pageSize=10,columns,renderRow,searchKeys=[]})=>{
  const [page,setPage]=useState(1);
  const [q,setQ]=useState("");
  const filtered = q ? data.filter(r=>searchKeys.some(k=>String(r[k]||"").toLowerCase().includes(q.toLowerCase()))) : data;
  const total=Math.ceil(filtered.length/pageSize)||1;
  const rows=filtered.slice((page-1)*pageSize,page*pageSize);
  return (
    <div>
      {searchKeys.length>0&&(
        <div style={{padding:"10px 14px",borderBottom:`1px solid ${C.border}`}}>
          <input value={q} onChange={e=>{setQ(e.target.value);setPage(1);}} placeholder="Search..."
            style={{background:C.elevated,border:`1px solid ${C.border}`,borderRadius:6,padding:"5px 10px",fontSize:12,color:C.text,width:220}}/>
        </div>
      )}
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",minWidth:600}}>
          <thead><tr>{columns.map((c,i)=><Th key={i} w={c.w}>{c.label}</Th>)}</tr></thead>
          <tbody>
            {rows.length===0&&<tr><td colSpan={columns.length} style={{padding:"24px",textAlign:"center",color:C.muted,fontSize:13}}>No data</td></tr>}
            {rows.map((r,i)=>renderRow(r,i))}
          </tbody>
        </table>
      </div>
      {filtered.length>pageSize&&(
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 14px",borderTop:`1px solid ${C.border}`}}>
          <span style={{fontSize:11,color:C.muted}}>{filtered.length} records · page {page}/{total}</span>
          <div style={{display:"flex",gap:6}}>
            <Btn small onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page===1}>Prev</Btn>
            <Btn small onClick={()=>setPage(p=>Math.min(total,p+1))} disabled={page===total}>Next →</Btn>
          </div>
        </div>
      )}
    </div>
  );
};

// ─── Overview ─────────────────────────────────────────────────────────────────
const TabOverview=({stats,cashflow,users,accounts,partnerMode,quota})=>{
  const mrr = cashflow?.signal_subscriptions?.mrr_usd||0;
  const activeSubs = cashflow?.signal_subscriptions?.active||0;
  const copySubs = cashflow?.copy_subscriptions?.active||0;
  const weeklySignups = cashflow?.user_growth?.weekly||0;
  return (
    <div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,minmax(0,1fr))",gap:10,marginBottom:16}}>
        <MetricCard label="Total users" value={stats.total_users??"-"} sub={`${stats.traders??0} traders · ${stats.analysts??0} analysts · ${stats.investors??0} investors`} color={C.accent}/>
        <MetricCard label="MRR (signal subs)" value={fmtUSD(mrr)} sub={`${activeSubs} active subscriptions`} color={C.success}/>
        <MetricCard label="Copy subscriptions" value={copySubs} sub="Active copy traders" color={C.warn}/>
        <MetricCard label="New users (7d)" value={weeklySignups} sub="This week" color={C.purple}/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,minmax(0,1fr))",gap:10,marginBottom:16}}>
        <MetricCard label="Trading accounts" value={stats.total_accounts??"-"} sub="MT4 + MT5" small/>
        <MetricCard label="Signal sets" value={stats.total_signal_sets??"-"} sub={`${stats.total_signals??0} signals`} small/>
        {partnerMode?<MetricCard label="Provider quota" value={quota?.max_providers==null?"No limit":`${quota.providers_used} / ${quota.max_providers}`} sub={`${quota?.providers_used??0} traders + analysts in use`} small/>:<MetricCard label="Active brokers" value={stats.active_brokers??"-"} sub="IB partners" small/>}
        {partnerMode?<MetricCard label="Investor quota" value={quota?.max_investors==null?"No limit":`${quota.investors_used} / ${quota.max_investors}`} sub={`${quota?.investors_used??0} investors in use`} small/>:<MetricCard label="Affiliate pending" value={fmtUSD(cashflow?.affiliate_payouts?.pending_usd)} sub="Awaiting payout" color={C.warn} small/>}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
        <Section title="Recent users">
          <PagedTable data={users.slice(0,10)} pageSize={5} searchKeys={[]}
            columns={[{label:"Name"},{label:"Email"},{label:"Role"},{label:"Status"}]}
            renderRow={(u,i)=>(
              <tr key={i} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
                <Td style={{fontWeight:600}}>{u.name||"-"}</Td>
                <Td style={{color:C.muted,fontSize:11}}>{u.email}</Td>
                <Td>{rolePill(u.primary_role)}</Td>
                <Td>{statusPill(u.status)}</Td>
              </tr>
            )}/>
        </Section>
        <Section title="Trading accounts">
          <PagedTable data={accounts.slice(0,10)} pageSize={5} searchKeys={[]}
            columns={[{label:"Account"},{label:"Broker"},{label:"Platform"},{label:"Balance"}]}
            renderRow={(a,i)=>(
              <tr key={i} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
                <Td><div style={{fontWeight:600,fontFamily:"monospace",color:C.accent}}>{a.account_number}</div><div style={{fontSize:10,color:C.muted}}>{a.user_email}</div></Td>
                <Td style={{fontSize:11,color:C.muted}}>{a.broker}</Td>
                <Td>{rolePill(a.platform?.toLowerCase())}</Td>
                <Td style={{color:C.success,fontWeight:600}}>${fmt(a.balance)}</Td>
              </tr>
            )}/>
        </Section>
      </div>
    </div>
  );
};

// ─── Users ────────────────────────────────────────────────────────────────────
const TabUsers=({users,reload})=>{
  const [editing,setEditing]=useState(null);
  const [form,setForm]=useState({});
  const [creating,setCreating]=useState(false);
  const [createForm,setCreateForm]=useState({email:"",password:"",name:"",role:"trader"});
  const [resetCapital,setResetCapital]=useState(null);
  const [newPassword,setNewPassword]=useState("");
  const openEdit=(u)=>{setEditing(u);setForm({name:u.name||"",primary_role:u.primary_role,status:u.status,is_admin:u.is_admin});};
  const save=async()=>{
    try{await adminAPI.updateUser(editing.id,form);setEditing(null);reload();}
    catch(e){alert(e.message);}
  };
  const del=async(u)=>{
    if(!window.confirm(`Delete user ${u.email}?`))return;
    try{await adminAPI.deleteUser(u.id);reload();}catch(e){alert(e.message);}
  };
  const createUser=async()=>{
    try{await adminAPI.createUser(createForm);setCreating(false);setCreateForm({email:"",password:"",name:"",role:"trader"});reload();alert("User created successfully");}
    catch(e){alert(""+e.message);}
  };
  const forceVerify=async(u)=>{
    if(!window.confirm(`Force verify email for ${u.email}?`))return;
    try{await adminAPI.forceVerifyEmail(u.id);reload();alert("Email verified");}
    catch(e){alert(""+e.message);}
  };
  const resetPassword=async()=>{
    if(!newPassword||newPassword.length<6){alert("Password min 6 characters");return;}
    try{await adminAPI.resetPassword(resetCapital.id,newPassword);setResetCapital(null);setNewPassword("");alert("Password reset");}
    catch(e){alert(""+e.message);}
  };
  const toggleSuspend=async(u)=>{
    const isSuspended = u.status==="suspended";
    const action = isSuspended ? "Unsuspend" : "Suspend";
    if(!window.confirm(`${action} user ${u.email}?`))return;
    try{
      await adminAPI.suspendUser(u.id, !isSuspended);
      reload();
      alert(`User ${action.toLowerCase()}ed`);
    }catch(e){alert(""+e.message);}
  };
  const impersonate=async(u)=>{
    if(!window.confirm(`Login as ${u.email}? Session valid 15 minutes.`))return;
    try{
      const r=await adminAPI.impersonateUser(u.id);
      const adminToken = localStorage.getItem("access_token")||localStorage.getItem("token")||"";
      window.open(`/impersonate?token=${r.token}&admin=${encodeURIComponent(adminToken)}`,'_blank');
    }
    catch(e){alert(""+e.message);}
  };
  const sel=(k)=>({value:form[k]??"",onChange:e=>setForm({...form,[k]:e.target.value}),
    style:{width:"100%",padding:"8px 10px",border:`1px solid ${C.border}`,borderRadius:6,fontSize:13,background:C.elevated,color:C.text}});
  return (
    <Section title={`Users (${users.length})`}>
      <PagedTable data={users} pageSize={10} searchKeys={["email","name","primary_role"]}
        columns={[{label:"Name"},{label:"Email"},{label:"Role"},{label:"Status"},{label:"Verified"},{label:"Admin"},{label:"Country"},{label:"Joined"},{label:"",w:220}]}
        renderRow={(u,i)=>(
          <tr key={i} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
            <Td style={{fontWeight:600}}>{u.name||"-"}</Td>
            <Td style={{fontSize:11,color:C.muted}}>{u.email}</Td>
            <Td>{rolePill(u.primary_role)}</Td>
            <Td>{statusPill(u.status)}</Td>
            <Td>{u.email_verified?<span style={{color:C.success}}></span>:<span style={{color:C.danger}}></span>}</Td>
            <Td>{u.is_admin?<span style={{color:C.purple,fontWeight:700,fontSize:11}}>Admin</span>:"-"}</Td>
            <Td style={{fontSize:11,color:C.muted}}>{u.country||"-"}</Td>
            <Td style={{fontSize:11,color:C.muted}}>{fmtDate(u.created_at)}</Td>
            <Td><div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
              <Btn small onClick={()=>openEdit(u)}>Edit</Btn>
              <Btn small onClick={()=>forceVerify(u)} style={{background:"rgba(29,209,161,0.15)",color:"var(--success)",border:"1px solid rgba(29,209,161,0.3)"}}> Verify</Btn>
              <Btn small onClick={()=>{setResetCapital(u);setNewPassword("");}} style={{background:"rgba(251,191,36,0.15)",color:"var(--warning)",border:"1px solid rgba(251,191,36,0.3)"}}> Pwd</Btn>
              <Btn small onClick={()=>impersonate(u)} style={{background:"rgba(139,92,246,0.15)",color:"var(--purple,#a78bfa)",border:"1px solid rgba(139,92,246,0.3)"}}> Login</Btn>
              <Btn small onClick={()=>toggleSuspend(u)} style={{
                background:u.status==="suspended"?"rgba(29,209,161,0.15)":"rgba(251,191,36,0.15)",
                color:u.status==="suspended"?"var(--success)":"var(--warning)",
                border:u.status==="suspended"?"1px solid rgba(29,209,161,0.3)":"1px solid rgba(251,191,36,0.3)"
              }}>{u.status==="suspended"?"▶ Unsuspend":"⏸ Suspend"}</Btn>
              <Btn small danger onClick={()=>del(u)}>Del</Btn>
            </div></Td>
          </tr>
        )}/>
      <div style={{marginBottom:12,display:"flex",justifyContent:"flex-end"}}>
        <Btn primary onClick={()=>setCreating(true)}>+ Create User</Btn>
      </div>
      {creating&&(
        <Capital title="Create New User" onClose={()=>setCreating(false)}>
          <Input label="Email *" value={createForm.email} onChange={e=>setCreateForm({...createForm,email:e.target.value})}/>
          <Input label="Password *" type="password" value={createForm.password} onChange={e=>setCreateForm({...createForm,password:e.target.value})}/>
          <Input label="Display Name" value={createForm.name} onChange={e=>setCreateForm({...createForm,name:e.target.value})}/>
          <div style={{marginBottom:12}}>
            <label style={{fontSize:11,color:C.muted,display:"block",marginBottom:4,fontWeight:600,textTransform:"uppercase"}}>Role</label>
            <select value={createForm.role} onChange={e=>setCreateForm({...createForm,role:e.target.value})}
              style={{width:"100%",padding:"8px 10px",border:`1px solid ${C.border}`,borderRadius:6,fontSize:13,background:C.elevated,color:C.text}}>
              <option value="trader">Trader</option>
              <option value="analyst">Analyst</option>
              <option value="investor">Investor</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          <div style={{fontSize:11,color:C.muted,marginBottom:12}}> Email will be auto-verified. User can login immediately.</div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <Btn onClick={()=>setCreating(false)}>Cancel</Btn>
            <Btn primary onClick={createUser}>Create User</Btn>
          </div>
        </Capital>
      )}
      {resetCapital&&(
        <Capital title={`Reset Password — ${resetCapital.email}`} onClose={()=>setResetCapital(null)}>
          <Input label="New Password (min 6 chars)" type="password" value={newPassword} onChange={e=>setNewPassword(e.target.value)}/>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <Btn onClick={()=>setResetCapital(null)}>Cancel</Btn>
            <Btn primary onClick={resetPassword}>Reset Password</Btn>
          </div>
        </Capital>
      )}

      
      {creating&&(
        <Capital title="Create New User" onClose={()=>setCreating(false)}>
          <Input label="Email *" value={createForm.email} onChange={e=>setCreateForm({...createForm,email:e.target.value})}/>
          <Input label="Password *" type="password" value={createForm.password} onChange={e=>setCreateForm({...createForm,password:e.target.value})}/>
          <Input label="Display Name" value={createForm.name} onChange={e=>setCreateForm({...createForm,name:e.target.value})}/>
          <div style={{marginBottom:12}}>
            <label style={{fontSize:11,color:C.muted,display:"block",marginBottom:4,fontWeight:600,textTransform:"uppercase"}}>Role</label>
            <select value={createForm.role} onChange={e=>setCreateForm({...createForm,role:e.target.value})}
              style={{width:"100%",padding:"8px 10px",border:`1px solid ${C.border}`,borderRadius:6,fontSize:13,background:C.elevated,color:C.text}}>
              <option value="trader">Trader</option>
              <option value="analyst">Analyst</option>
              <option value="investor">Investor</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          <div style={{fontSize:11,color:C.muted,marginBottom:12}}> Email will be auto-verified. User can login immediately.</div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <Btn onClick={()=>setCreating(false)}>Cancel</Btn>
            <Btn primary onClick={createUser}>Create User</Btn>
          </div>
        </Capital>
      )}
      {resetCapital&&(
        <Capital title={`Reset Password — ${resetCapital.email}`} onClose={()=>setResetCapital(null)}>
          <Input label="New Password (min 6 chars)" type="password" value={newPassword} onChange={e=>setNewPassword(e.target.value)}/>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <Btn onClick={()=>setResetCapital(null)}>Cancel</Btn>
            <Btn primary onClick={resetPassword}>Reset Password</Btn>
          </div>
        </Capital>
      )}

      {editing&&(
        <Capital title={`Edit — ${editing.email}`} onClose={()=>setEditing(null)}>
          <Input label="Display name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})}/>
          <div style={{marginBottom:12}}>
            <label style={{fontSize:11,color:C.muted,display:"block",marginBottom:4,fontWeight:600,textTransform:"uppercase"}}>Role</label>
            <select {...sel("primary_role")}><option value="trader">Trader</option><option value="analyst">Analyst</option><option value="investor">Investor</option><option value="admin">Admin</option></select>
          </div>
          <div style={{marginBottom:12}}>
            <label style={{fontSize:11,color:C.muted,display:"block",marginBottom:4,fontWeight:600,textTransform:"uppercase"}}>Status</label>
            <select {...sel("status")}><option value="active">Active</option><option value="suspended">Suspended</option></select>
          </div>
          <div style={{marginBottom:16,display:"flex",alignItems:"center",gap:8}}>
            <input type="checkbox" id="is_admin" checked={!!form.is_admin} onChange={e=>setForm({...form,is_admin:e.target.checked})}/>
            <label htmlFor="is_admin" style={{fontSize:13,color:C.text}}>Platform admin</label>
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <Btn onClick={()=>setEditing(null)}>Cancel</Btn>
            <Btn primary onClick={save}>Save</Btn>
          </div>
        </Capital>
      )}
    </Section>
  );
};

// ─── Trading Accounts ─────────────────────────────────────────────────────────
const TabAccounts=({accounts,brokers,reload,users,token})=>{
  const [editIB,setEditIB]=useState(null);
  const [showCreateAcc,setShowCreateAcc]=useState(false);
  const [createAccForm,setCreateAccForm]=useState({user_id:"",account_number:"",broker:"",platform:"MT5",server:"",currency:"USD",account_role:"provider"});
  const [creatingAcc,setCreatingAcc]=useState(false);
  const doCreateAccount=async()=>{
    if(!createAccForm.user_id||!createAccForm.account_number||!createAccForm.broker){alert("user, account number, broker required");return;}
    setCreatingAcc(true);
    try{
      const res=await fetch("/api/admin/trading-accounts",{method:"POST",headers:{"Content-Type":"application/json",Authorization:`Bearer ${token}`},body:JSON.stringify(createAccForm)});
      const data=await res.json();
      if(data.ok){alert(`Account ${data.account} created for ${data.user}`);setShowCreateAcc(false);setCreateAccForm({user_id:"",account_number:"",broker:"",platform:"mt5",server:"",currency:"USD",account_role:"trader"});reload();}
      else alert("Error: "+data.error);
    }catch(e){alert(e.message);}finally{setCreatingAcc(false);}
  };
  const [editCurrency,setEditCurrency]=useState(null);
  const [currencyVal,setCurrencyVal]=useState("USD");
  const [ibForm,setIBForm]=useState({uses_platform_ib:false,ib_broker_id:""});
  const delAccount=async(a)=>{
    if(!window.confirm(`Disable account ${a.account_number} (${a.user_email})? This will set status to disabled.`))return;
    try{await adminAPI.deleteTradingAccount(a.id);reload();alert("Account disabled");}
    catch(e){alert(""+e.message);}
  };
  const saveCurrency=async()=>{
    try{
      await adminAPI.updateAccountCurrency(editCurrency.id, currencyVal);
      setEditCurrency(null); reload();
    }catch(e){alert(e.message);}
  };
  const saveIB=async()=>{
    try{
      await adminAPI.updateIBStatus(editIB.id,ibForm.uses_platform_ib,ibForm.ib_broker_id||null);
      setEditIB(null); reload();
    }catch(e){alert(e.message);}
  };
  return (
    <Section title={`Trading accounts (${accounts.length})`} action={<Btn onClick={()=>setShowCreateAcc(true)}>+ Add Account</Btn>}>
      <PagedTable data={accounts} pageSize={10} searchKeys={["account_number","broker","user_email","user_name"]}
        columns={[{label:"Account #"},{label:"Owner"},{label:"Broker"},{label:"Platform"},{label:"Balance"},{label:"Equity"},{label:"IB"},{label:"Status"},{label:"Created"},{label:"",w:60}]}
        renderRow={(a,i)=>(
          <tr key={i} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
            <Td style={{fontWeight:600,fontFamily:"monospace",color:C.accent}}>{a.account_number}</Td>
            <Td><div style={{fontSize:12}}>{a.user_name||"-"}</div><div style={{fontSize:10,color:C.muted}}>{a.user_email}</div></Td>
            <Td style={{fontSize:11,color:C.muted}}>{a.broker}</Td>
            <Td>{rolePill(a.platform?.toLowerCase())}</Td>
            <Td style={{color:C.success,fontWeight:600}}>${fmt(a.balance)}</Td>
            <Td>${fmt(a.equity)}</Td>
            <Td style={{fontWeight:700,color:(a.alpha_score||0)>=70?C.success:(a.alpha_score||0)>=50?C.warn:C.danger,fontSize:12}}>{(a.alpha_score||0)>0?(a.alpha_score).toFixed(1):"-"}</Td>
            <Td style={{fontWeight:600,fontSize:12,color:C.text}}>{a.grade||"-"}</Td>
            <Td style={{fontSize:12,color:C.text}}>{(a.win_rate||0)>0?(a.win_rate).toFixed(1)+"%":"-"}</Td>
            <Td style={{fontSize:12,color:(a.roi||0)>=0?C.success:C.danger,fontWeight:600}}>{(a.roi||0)!==0?((a.roi||0)>0?"+":"")+(a.roi).toFixed(1)+"%":"-"}</Td>
            <Td style={{fontSize:12,color:(a.max_drawdown_pct||0)>20?C.danger:(a.max_drawdown_pct||0)>10?C.warn:C.text}}>{(a.max_drawdown_pct||0)>0?(a.max_drawdown_pct).toFixed(1)+"%":"-"}</Td>
            <Td>
              {a.uses_platform_ib
                ?<span style={{background:C.success+"22",color:C.success,fontSize:11,padding:"2px 8px",borderRadius:6,fontWeight:600}}>IB {a.ib_broker_name?" · "+a.ib_broker_name:""}</span>
                :<span style={{background:C.muted+"22",color:C.muted,fontSize:11,padding:"2px 8px",borderRadius:6}}>Non-IB</span>}
            </Td>
            <Td>{statusPill(a.status)}</Td>
            <Td style={{fontSize:11,color:C.muted}}>{fmtDate(a.created_at)}</Td>
            <Td><Btn small onClick={()=>{setEditIB(a);setIBForm({uses_platform_ib:a.uses_platform_ib,ib_broker_id:""});}}>IB</Btn>
              <Btn small onClick={()=>{setEditCurrency(a);setCurrencyVal(a.currency||"USD");}}>CCY</Btn>
              <Btn small danger onClick={()=>delAccount(a)}>Del</Btn></Td>
          </tr>
        )}/>
      {editCurrency&&(
        <Capital title={`Set Currency — ${editCurrency.account_number}`} onClose={()=>setEditCurrency(null)}>
          <div style={{marginBottom:16}}>
            <label style={{fontSize:11,color:C.muted,display:"block",marginBottom:8,fontWeight:600,textTransform:"uppercase"}}>Account Currency</label>
            <div style={{display:"flex",gap:8}}>
              {["USD","USC"].map(v=>(
                <button key={v} type="button"
                  onClick={()=>setCurrencyVal(v)}
                  style={{flex:1,padding:"10px",borderRadius:6,border:`1px solid ${currencyVal===v?C.accent:C.border}`,background:currencyVal===v?"rgba(78,154,241,0.15)":"transparent",color:currencyVal===v?C.accent:C.muted,fontWeight:600,cursor:"pointer"}}>
                  {v==="USD"?"Standard (USD)":"Cent (USC)"}</button>
              ))}
            </div>
            <div style={{fontSize:11,color:C.muted,marginTop:8}}>USC = Cent account. Values in marketplace shown in USC.</div>
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <Btn onClick={()=>setEditCurrency(null)}>Cancel</Btn>
            <Btn primary onClick={saveCurrency}>Save</Btn>
          </div>
        </Capital>
      )}
      {editIB&&(
        <Capital title={`Set IB — ${editIB.account_number}`} onClose={()=>setEditIB(null)}>
          <div style={{background:C.elevated,borderRadius:8,padding:"12px",marginBottom:16,fontSize:12,color:C.muted}}>
            Toggle IB status akun ini. Mempengaruhi split rebate di Fee Report.
          </div>
          <div style={{marginBottom:16,display:"flex",alignItems:"center",gap:10}}>
            <input type="checkbox" id="ib_tog" checked={ibForm.uses_platform_ib}
              onChange={e=>setIBForm({...ibForm,uses_platform_ib:e.target.checked})}/>
            <label htmlFor="ib_tog" style={{fontSize:13,color:C.text,fontWeight:600}}>Account dibuka via IB CrunchAlpha</label>
          </div>
          {ibForm.uses_platform_ib&&(
            <div style={{marginBottom:16}}>
              <label style={{fontSize:11,color:C.muted,display:"block",marginBottom:4,fontWeight:600,textTransform:"uppercase"}}>IB Broker</label>
              <select value={ibForm.ib_broker_id} onChange={e=>setIBForm({...ibForm,ib_broker_id:e.target.value})}
                style={{width:"100%",padding:"8px 10px",border:`1px solid ${C.border}`,borderRadius:6,fontSize:13,background:C.elevated,color:C.text}}>
                <option value="">— Select broker —</option>
                {(brokers||[]).map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
              </select>
            </div>
          )}
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <Btn onClick={()=>setEditIB(null)}>Cancel</Btn>
            <Btn primary onClick={saveIB}>Save</Btn>
          </div>
        </Capital>
      )}
      {showCreateAcc&&(
        <Capital title="Add Trading Account" onClose={()=>setShowCreateAcc(false)}>
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            <div>
              <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:4}}>User *</div>
              <select value={createAccForm.user_id} onChange={e=>setCreateAccForm({...createAccForm,user_id:e.target.value})}
                style={{width:"100%",background:C.elevated,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",fontSize:13,color:C.text,colorScheme:"dark"}}>
                <option value="">-- Select user --</option>
                {(users||[]).map(u=><option key={u.id} value={u.id}>{u.name||u.email} ({u.primary_role||u.role})</option>)}
              </select>
            </div>
            <div>
              <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:4}}>Account Number *</div>
              <input value={createAccForm.account_number} onChange={e=>setCreateAccForm({...createAccForm,account_number:e.target.value})}
                style={{width:"100%",background:C.elevated,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",fontSize:13,color:C.text,boxSizing:"border-box"}} placeholder="e.g. 12345678"/>
            </div>
            <div>
              <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:4}}>Broker *</div>
              <input value={createAccForm.broker} onChange={e=>setCreateAccForm({...createAccForm,broker:e.target.value})}
                style={{width:"100%",background:C.elevated,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",fontSize:13,color:C.text,boxSizing:"border-box"}} placeholder="e.g. FBS, Dupoin"/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div>
                <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:4}}>Platform *</div>
                <select value={createAccForm.platform} onChange={e=>setCreateAccForm({...createAccForm,platform:e.target.value})}
                  style={{width:"100%",background:C.elevated,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",fontSize:13,color:C.text,colorScheme:"dark"}}>
                  <option value="MT5">MT5</option>
                  <option value="MT4">MT4</option>
                </select>
              </div>
              <div>
                <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:4}}>Role</div>
                <select value={createAccForm.account_role} onChange={e=>setCreateAccForm({...createAccForm,account_role:e.target.value})}
                  style={{width:"100%",background:C.elevated,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",fontSize:13,color:C.text,colorScheme:"dark"}}>
                  <option value="provider">Provider (Trader)</option>
                  <option value="follower">Follower (Investor)</option>
                  <option value="both">Both</option>
                </select>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div>
                <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:4}}>Server</div>
                <input value={createAccForm.server} onChange={e=>setCreateAccForm({...createAccForm,server:e.target.value})}
                  style={{width:"100%",background:C.elevated,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",fontSize:13,color:C.text,boxSizing:"border-box"}} placeholder="e.g. FBS-Real"/>
              </div>
              <div>
                <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:4}}>Currency</div>
                <select value={createAccForm.currency} onChange={e=>setCreateAccForm({...createAccForm,currency:e.target.value})}
                  style={{width:"100%",background:C.elevated,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",fontSize:13,color:C.text,colorScheme:"dark"}}>
                  <option value="USD">USD (Standard)</option>
                  <option value="USC">USC (Cent)</option>
                </select>
              </div>
            </div>
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:20}}>
            <Btn onClick={()=>setShowCreateAcc(false)}>Cancel</Btn>
            <Btn primary onClick={doCreateAccount} disabled={creatingAcc}>{creatingAcc?"Creating...":"Create Account"}</Btn>
          </div>
        </Capital>
      )}
    </Section>
  );
};

// ─── Signal Sets ──────────────────────────────────────────────────────────────
const TabSignalSets=({sets,token,users})=>{
  const [showImport,setShowImport]=useState(false);
  const [importSetId,setImportSetId]=useState("");
  const [importFile,setImportFile]=useState(null);
  const [importResult,setImportResult]=useState(null);
  const [importing,setImporting]=useState(false);
  const [deletingId,setDeletingId]=useState(null);
  const [showCreateSet,setShowCreateSet]=useState(false);
  const [createSetForm,setCreateSetForm]=useState({analyst_id:"",name:"",description:""});
  const [creatingSet,setCreatingSet]=useState(false);
  const analysts=(users||[]).filter(u=>u.role==="analyst"||u.primary_role==="analyst");
  const doCreateSet=async()=>{
    if(!createSetForm.analyst_id||!createSetForm.name){alert("analyst and name required");return;}
    setCreatingSet(true);
    try{
      const res=await fetch("/api/admin/signal-sets",{method:"POST",headers:{"Content-Type":"application/json",Authorization:`Bearer ${token}`},body:JSON.stringify(createSetForm)});
      const data=await res.json();
      if(data.ok){alert(`Signal set "${data.name}" created for ${data.analyst}`);setShowCreateSet(false);setCreateSetForm({analyst_id:"",name:"",description:""});window.location.reload();}
      else alert("Error: "+data.error);
    }catch(e){alert(e.message);}finally{setCreatingSet(false);}
  };

  const doDelete=async(s)=>{
    if(!window.confirm(`DELETE signal set "${s.name}" and ALL its signals? This cannot be undone.`))return;
    setDeletingId(s.id);
    try{
      const res=await fetch(`/api/admin/signal-sets/${s.id}`,{method:"DELETE",headers:{Authorization:`Bearer ${token}`}});
      const data=await res.json();
      if(data.ok){alert(`Deleted "${data.deleted_set}" — ${data.deleted_signals} signals removed.`);window.location.reload();}
      else alert("Error: "+data.error);
    }catch(e){alert(e.message);}finally{setDeletingId(null);}
  };

  const doExport=async(s)=>{
    try{
      const res=await fetch(`/api/admin/signals/export/${s.id}`,{headers:{Authorization:`Bearer ${token}`}});
      const blob=await res.blob();
      const url=URL.createObjectURL(blob);
      const a=document.createElement("a");
      a.href=url;a.download=`signals_${s.name.replace(/\s+/g,"_")}.csv`;a.click();
      URL.revokeObjectURL(url);
    }catch(e){alert(e.message);}
  };

  const doImport=async()=>{
    if(!importSetId){alert("Select a signal set");return;}
    if(!importFile){alert("Select a CSV file");return;}
    setImporting(true);setImportResult(null);
    try{
      const fd=new FormData();
      fd.append("set_id",importSetId);
      fd.append("file",importFile);
      const res=await fetch("/api/admin/signals/import",{method:"POST",headers:{Authorization:`Bearer ${token}`},body:fd});
      const data=await res.json();
      setImportResult(data);
    }catch(e){alert(e.message);}finally{setImporting(false);}
  };

  const downloadTemplate=()=>{
    const csv = "pair,direction,entry,sl,tp,status,issued_at,closed_at\nXAUUSD,BUY,2950.00,2930.00,2980.00,CLOSED_TP,2026-01-15 08:00:00,2026-01-15 14:30:00\nEURUSD,SELL,1.0850,1.0900,1.0780,CLOSED_SL,2026-01-16 09:00:00,2026-01-16 11:00:00\nGBPUSD,BUY,1.2700,1.2650,1.2800,CLOSED_TP,2026-01-17 10:00:00,2026-01-17 16:00:00\nXAGUSD,SELL,32.50,33.00,31.50,CANCELLED_MANUAL,2026-01-18 09:00:00,2026-01-18 10:00:00\n";
    const blob = new Blob([csv], {type:"text/csv"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "signal_import_template.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return(
  <>
  <Section title={`Analyst signal sets (${sets.length})`} action={<div style={{display:"flex",gap:8}}><Btn onClick={()=>setShowCreateSet(true)}>+ Create Set</Btn><Btn onClick={()=>{setShowImport(true);setImportResult(null);}}>+ Import History</Btn></div>}>
    <PagedTable data={sets} pageSize={10} searchKeys={["name","analyst_email","analyst_name"]}
      columns={[{label:"Name"},{label:"Analyst"},{label:"Signals"},{label:"Score"},{label:"Grade"},{label:"Win rate"},{label:"PF"},{label:"Status"},{label:"Created"},{label:"Actions"}]}
      renderRow={(s,i)=>(
        <tr key={i} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
          <Td style={{fontWeight:600}}>{s.name}</Td>
          <Td><div style={{fontSize:12}}>{s.analyst_name||"-"}</div><div style={{fontSize:10,color:C.muted}}>{s.analyst_email}</div></Td>
          <Td style={{color:C.accent}}>{s.subscribers_count}</Td>
          <Td style={{fontWeight:700,color:s.virtual_alpha_score>=70?C.success:s.virtual_alpha_score>=50?C.warn:C.danger,fontSize:12}}>{s.virtual_alpha_score>0?s.virtual_alpha_score.toFixed(1):"-"}</Td>
          <Td style={{fontWeight:600,fontSize:12,color:C.text}}>{s.virtual_alpha_grade||"-"}</Td>
          <Td style={{color:C.success,fontWeight:600}}>{fmtPct(s.win_rate)}</Td>
          <Td style={{color:C.warn,fontWeight:600}}>{s.profit_factor?Number(s.profit_factor).toFixed(2):"-"}</Td>
          <Td>{statusPill(s.status)}</Td>
          <Td style={{fontSize:11,color:C.muted}}>{fmtDate(s.created_at)}</Td>
          <Td>
            <div style={{display:"flex",gap:6}}>
              <button onClick={()=>doExport(s)} style={{fontSize:11,padding:"4px 10px",borderRadius:6,border:`1px solid ${C.border}`,background:"none",color:C.accent,cursor:"pointer",fontWeight:600}}>Export</button>
              <button onClick={()=>doDelete(s)} disabled={deletingId===s.id} style={{fontSize:11,padding:"4px 10px",borderRadius:6,border:"none",background:"rgba(255,92,122,0.15)",color:"var(--danger)",cursor:"pointer",fontWeight:600,opacity:deletingId===s.id?0.5:1}}>{deletingId===s.id?"...":"Delete"}</button>
            </div>
          </Td>
        </tr>
      )}/>
  </Section>

  {showCreateSet&&(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={e=>e.target===e.currentTarget&&setShowCreateSet(false)}>
      <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,padding:32,width:"100%",maxWidth:480}}>
        <div style={{fontSize:16,fontWeight:800,color:C.text,marginBottom:4}}>Create Signal Set</div>
        <div style={{fontSize:12,color:C.muted,marginBottom:20}}>Create a new signal set for an analyst account.</div>
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <div>
            <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:4}}>Analyst *</div>
            <select value={createSetForm.analyst_id} onChange={e=>setCreateSetForm({...createSetForm,analyst_id:e.target.value})}
              style={{width:"100%",background:C.elevated,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",fontSize:13,color:C.text,colorScheme:"dark"}}>
              <option value="">-- Select analyst --</option>
              {analysts.map(u=><option key={u.id} value={u.id}>{u.name||u.email} — {u.email}</option>)}
            </select>
          </div>
          <div>
            <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:4}}>Signal Set Name *</div>
            <input value={createSetForm.name} onChange={e=>setCreateSetForm({...createSetForm,name:e.target.value})}
              style={{width:"100%",background:C.elevated,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",fontSize:13,color:C.text,boxSizing:"border-box"}} placeholder="e.g. Gold Swing Alpha"/>
          </div>
          <div>
            <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:4}}>Description</div>
            <textarea value={createSetForm.description} onChange={e=>setCreateSetForm({...createSetForm,description:e.target.value})}
              style={{width:"100%",background:C.elevated,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",fontSize:13,color:C.text,boxSizing:"border-box",height:72,resize:"vertical"}} placeholder="Strategy description..."/>
          </div>
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:20}}>
          <button onClick={()=>setShowCreateSet(false)} style={{padding:"10px 20px",borderRadius:8,border:`1px solid ${C.border}`,background:"none",color:C.muted,cursor:"pointer",fontSize:13}}>Cancel</button>
          <button onClick={doCreateSet} disabled={creatingSet} style={{padding:"10px 20px",borderRadius:8,border:"none",background:C.accent,color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,opacity:creatingSet?0.6:1}}>{creatingSet?"Creating...":"Create Signal Set"}</button>
        </div>
      </div>
    </div>
  )}
  {showImport&&(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={e=>e.target===e.currentTarget&&setShowImport(false)}>
      <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,padding:32,width:"100%",maxWidth:520}}>
        <div style={{fontSize:16,fontWeight:800,color:C.text,marginBottom:4}}>Import Signal History</div>
        <div style={{fontSize:12,color:C.muted,marginBottom:20}}>Admin only — upload verified historical signals via CSV. Admin wajib cross-check dengan bukti (screenshot Telegram dll) sebelum import.</div>

        <div style={{marginBottom:14}}>
          <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:"0.04em",marginBottom:6}}>Signal Set *</div>
          <select value={importSetId} onChange={e=>setImportSetId(e.target.value)} style={{width:"100%",background:C.elevated,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",fontSize:13,color:C.text,colorScheme:"dark"}}>
            <option value="">-- Select signal set --</option>
            {sets.map(s=><option key={s.id} value={s.id}>{s.name} — {s.analyst_name||s.analyst_email}</option>)}
          </select>
        </div>

        <div style={{marginBottom:14}}>
          <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:"0.04em",marginBottom:6}}>CSV File *</div>
          <input type="file" accept=".csv" onChange={e=>setImportFile(e.target.files[0])} style={{width:"100%",background:C.elevated,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",fontSize:13,color:C.text}}/>
        </div>

        <div style={{marginBottom:20,padding:"12px 16px",background:C.elevated,borderRadius:8,border:`1px solid ${C.border}`}}>
          <div style={{fontSize:11,fontWeight:700,color:C.muted,marginBottom:6}}>FORMAT CSV (kolom wajib):</div>
          <code style={{fontSize:11,color:C.accent}}>pair, direction, entry, sl, tp, status, issued_at, closed_at</code>
          <div style={{fontSize:11,color:C.muted,marginTop:4}}>status: <span style={{color:"var(--success)"}}>CLOSED_TP</span> / <span style={{color:"var(--danger)"}}>CLOSED_SL</span> / <span style={{color:"var(--warning)"}}>CANCELLED_MANUAL</span></div>
          <div style={{fontSize:11,color:C.muted}}>issued_at/closed_at: <span style={{color:C.text}}>YYYY-MM-DD HH:MM</span> atau <span style={{color:C.text}}>M/D/YYYY H:MM</span></div>
          <button onClick={downloadTemplate} style={{marginTop:8,fontSize:11,color:C.accent,background:"none",border:"none",cursor:"pointer",padding:0,textDecoration:"underline"}}>Download template CSV</button>
        </div>

        {importResult&&(
          <div style={{marginBottom:16,padding:"12px 16px",background:importResult.ok?"rgba(29,209,161,0.1)":"rgba(255,92,122,0.1)",borderRadius:8,border:`1px solid ${importResult.ok?C.success:C.danger}`}}>
            {importResult.ok?(
              <>
                <div style={{fontSize:13,fontWeight:700,color:C.success}}> Imported {importResult.imported} signals, skipped {importResult.skipped}</div>
                {importResult.rows?.filter(r=>r.error).map((r,i)=>(
                  <div key={i} style={{fontSize:11,color:C.danger,marginTop:4}}>Row {r.row}: {r.pair} — {r.error}</div>
                ))}
              </>
            ):(
              <div style={{fontSize:13,color:C.danger}}>Error: {importResult.error}</div>
            )}
          </div>
        )}

        <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
          <button onClick={()=>setShowImport(false)} style={{padding:"10px 20px",borderRadius:8,border:`1px solid ${C.border}`,background:"none",color:C.muted,cursor:"pointer",fontSize:13}}>Cancel</button>
          <button onClick={doImport} disabled={importing} style={{padding:"10px 20px",borderRadius:8,border:"none",background:C.accent,color:"var(--text-main)",cursor:"pointer",fontSize:13,fontWeight:700,opacity:importing?0.6:1}}>
            {importing?"Importing...":"Import Signals"}
          </button>
        </div>
      </div>
    </div>
  )}
  </>
  );
};

// ─── Brokers ──────────────────────────────────────────────────────────────────
const TabBrokers=({brokers,reload})=>{
  const [showAdd,setShowAdd]=useState(false);
  const [editing,setEditing]=useState(null);
  const empty={name:"",website_url:"",referral_link:"",logo_url:"",broker_pays_per_lot:"",min_deposit:"",is_recommended:false,is_active:true,show_in_ticker:false,description:"",display_order:0,regulation:"",leverage:"1:500",rating:"4.0",headquarters:"",hq_country_code:"",year_founded:"",trading_instruments:""};
  const [form,setForm]=useState(empty);
  const openAdd=()=>{setForm(empty);setEditing(null);setShowAdd(true);};
  const openEdit=(b)=>{setForm({...b,referral_link:b.referral_link||"",description:b.description||"",logo_url:b.logo_url||"",regulation:b.regulation||"",leverage:b.leverage||"1:500",rating:b.rating||"4.0",headquarters:b.headquarters||"",hq_country_code:b.hq_country_code||"",year_founded:b.year_founded||"",trading_instruments:b.trading_instruments||""});setEditing(b);setShowAdd(true);};
  const save=async()=>{
    try{
      const p={...form,broker_pays_per_lot:parseFloat(form.broker_pays_per_lot)||0,min_deposit:parseFloat(form.min_deposit)||0,display_order:parseInt(form.display_order)||0,rating:parseFloat(form.rating)||4.0,year_founded:parseInt(form.year_founded)||0};
      if(editing)await adminAPI.updateBroker(editing.id,p);
      else await adminAPI.createBroker(p);
      setShowAdd(false);reload();
    }catch(e){alert(e.message);}
  };
  const del=async(b)=>{
    if(!window.confirm(`Delete broker ${b.name}?`))return;
    try{await adminAPI.deleteBroker(b.id);reload();}catch(e){alert(e.message);}
  };
  const f=(k)=>({value:form[k]??"",onChange:e=>setForm({...form,[k]:e.target.value})});
  const starRating=(r)=>{const n=Math.round(parseFloat(r)||0);return "".repeat(n)+"".repeat(5-n);};
  return (
    <Section title={`Broker partners (${brokers.length})`} action={<Btn onClick={openAdd}>+ Add broker</Btn>}>
      <PagedTable data={brokers} pageSize={10} searchKeys={["name","website_url","headquarters"]}
        columns={[{label:"Broker"},{label:"HQ / Country"},{label:"Regulation"},{label:"Leverage"},{label:"Rating"},{label:"Rebate/lot"},{label:"Min dep."},{label:"Rec."},{label:"Active"},{label:"",w:90}]}
        renderRow={(b,i)=>(
          <tr key={i} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
            <Td>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                {b.logo_url?<img src={b.logo_url} alt={b.name} style={{width:24,height:24,borderRadius:4,objectFit:"contain",background:"#fff",padding:2}}/>:<div style={{width:24,height:24,borderRadius:4,background:C.elevated,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,color:C.muted}}>{b.name[0]}</div>}
                <div>
                  <div style={{fontWeight:600,fontSize:12}}>{b.name}</div>
                  <a href={b.referral_link||b.website_url} target="_blank" rel="noreferrer" style={{color:C.accent,fontSize:10}}>{(b.referral_link||b.website_url)?.replace("https://","").split("/")[0]}</a>
                </div>
              </div>
            </Td>
            <Td><div style={{fontSize:12}}>{b.headquarters||"-"}</div><div style={{fontSize:10,color:C.muted}}>{b.hq_country_code||""} {b.year_founded?`· est. ${b.year_founded}`:""}</div></Td>
            <Td style={{fontSize:11,color:C.muted}}>{b.regulation||"-"}</Td>
            <Td style={{fontSize:11}}>{b.leverage||"-"}</Td>
            <Td><span style={{color:"var(--warning)",fontSize:12}}>{starRating(b.rating)}</span><span style={{fontSize:10,color:C.muted,marginLeft:4}}>{b.rating}</span></Td>
            <Td><span style={{fontWeight:700,color:C.success,fontSize:12}}>${fmt(b.broker_pays_per_lot)}/lot</span></Td>
            <Td style={{fontSize:12}}>${fmt(b.min_deposit)}</Td>
            <Td>{b.is_recommended?<span style={{color:C.success}}></span>:"-"}</Td>
            <Td>{b.show_in_ticker?<span style={{color:C.accent,fontWeight:700}}> Ticker</span>:"-"}</Td>
            <Td>{statusPill(b.is_active?"active":"inactive")}</Td>
            <Td><div style={{display:"flex",gap:4}}><Btn small onClick={()=>openEdit(b)}>Edit</Btn><Btn small danger onClick={()=>del(b)}>Del</Btn></div></Td>
          </tr>
        )}/>
      {showAdd&&(
        <Capital title={editing?`Edit — ${editing.name}`:"Add broker partner"} onClose={()=>setShowAdd(false)}>
          <div style={{maxHeight:"70vh",overflowY:"auto",paddingRight:4}}>
            <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:8,paddingBottom:4,borderBottom:`1px solid ${C.border}`}}>Basic Info</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 12px"}}>
              <Input label="Broker name *" {...f("name")}/>
              <Input label="Website URL *" {...f("website_url")} placeholder="https://..."/>
              <Input label="Logo URL" {...f("logo_url")} placeholder="https://...broker-logo.png"/>
              <Input label="Referral / IB link" {...f("referral_link")} placeholder="https://..."/>
              <Input label="Min deposit ($)" type="number" {...f("min_deposit")}/>
              <Input label="Rebate/lot — broker pays ($)" type="number" {...f("broker_pays_per_lot")} placeholder="e.g. 1"/>
              <Input label="Display order" type="number" {...f("display_order")}/>
            </div>
            <Input label="Description (shown to users)" {...f("description")}/>
            <div style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:"0.05em",margin:"12px 0 8px",paddingBottom:4,borderBottom:`1px solid ${C.border}`}}>Broker Profilee (Public Page)</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 12px"}}>
              <Input label="Headquarters (city, country)" {...f("headquarters")} placeholder="Jakarta, Indonesia"/>
              <Input label="HQ Country code (2-letter)" {...f("hq_country_code")} placeholder="ID / SG / CY / SC"/>
              <Input label="Regulation" {...f("regulation")} placeholder="OJK, CySEC, FSA, ASIC..."/>
              <Input label="Leverage" {...f("leverage")} placeholder="1:500"/>
              <Input label="Rating (0-5)" type="number" {...f("rating")} placeholder="4.5"/>
              <Input label="Year founded" type="number" {...f("year_founded")} placeholder="2010"/>
            </div>
            <Input label="Trading instruments (Forex, Gold, Indices, Crypto...)" {...f("trading_instruments")}/>
            <div style={{display:"flex",gap:16,marginBottom:16,marginTop:8}}>
              <label style={{display:"flex",alignItems:"center",gap:6,fontSize:13,color:C.text}}><input type="checkbox" checked={!!form.is_recommended} onChange={e=>setForm({...form,is_recommended:e.target.checked})}/> Recommended</label>
              <label style={{display:"flex",alignItems:"center",gap:6,fontSize:13,color:C.text}}><input type="checkbox" checked={!!form.is_active} onChange={e=>setForm({...form,is_active:e.target.checked})}/> Active (show in /brokers marketplace)</label>
              <label style={{display:"flex",alignItems:"center",gap:6,fontSize:13,color:C.accent,fontWeight:600}}><input type="checkbox" checked={!!form.show_in_ticker} onChange={e=>setForm({...form,show_in_ticker:e.target.checked})}/>  Show in homepage ticker (hanya 1 broker)</label>
            </div>
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:8,paddingTop:8,borderTop:`1px solid ${C.border}`}}>
            <Btn onClick={()=>setShowAdd(false)}>Cancel</Btn>
            <Btn primary onClick={save}>Save broker</Btn>
          </div>
        </Capital>
      )}
    </Section>
  );
};

// ─── Cashflow ─────────────────────────────────────────────────────────────────
const TabCashflow=({cashflow,signalSubs,copySubs})=>{
  const mrr=cashflow?.signal_subscriptions?.mrr_usd||0;
  const activeSubs=cashflow?.signal_subscriptions?.active||0;
  const totalSubs=cashflow?.signal_subscriptions?.total||0;
  const churnRate=totalSubs>0?((totalSubs-activeSubs)/totalSubs*100):0;
  const copySubs_=cashflow?.copy_subscriptions?.active||0;
  const pendingPayout=cashflow?.affiliate_payouts?.pending_usd||0;
  const paidPayout=cashflow?.affiliate_payouts?.paid_usd||0;
  return (
    <div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,minmax(0,1fr))",gap:10,marginBottom:16}}>
        <MetricCard label="MRR (signal subs)" value={fmtUSD(mrr)} sub={`${activeSubs} active · ${totalSubs} total`} color={C.success}/>
        <MetricCard label="Churn rate" value={fmtPct(churnRate)} sub={`${totalSubs-activeSubs} cancelled`} color={churnRate>20?C.danger:C.warn}/>
        <MetricCard label="Active copy subs" value={copySubs_} sub="Copy trading" color={C.accent}/>
        <MetricCard label="Pending payouts" value={fmtUSD(pendingPayout)} sub={`Paid: ${fmtUSD(paidPayout)}`} color={C.warn}/>
      </div>

      <Section title="Signal subscriptions — revenue">
        <PagedTable data={signalSubs} pageSize={10} searchKeys={["investor_email","analyst_email","signal_set_name"]}
          columns={[{label:"Signal set"},{label:"Investor"},{label:"Analyst"},{label:"Fee/mo"},{label:"Status"},{label:"Billing"},{label:"Started"},{label:"Expires"},{label:"Cancelled"}]}
          renderRow={(s,i)=>(
            <tr key={i} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
              <Td style={{fontWeight:600,fontSize:11}}>{s.signal_set_name||"-"}</Td>
              <Td style={{fontSize:11,color:C.muted}}>{s.investor_email||"-"}</Td>
              <Td style={{fontSize:11,color:C.muted}}>{s.analyst_email||"-"}</Td>
              <Td style={{color:C.success,fontWeight:700}}>{fmtUSD(s.fee)}</Td>
              <Td>{statusPill(s.status)}</Td>
              <Td style={{fontSize:11}}>{s.billing_cycle}</Td>
              <Td style={{fontSize:11,color:C.muted}}>{fmtDate(s.started_at)}</Td>
              <Td style={{fontSize:11,color:s.expires_at&&new Date(s.expires_at)<new Date()?C.danger:C.muted}}>{fmtDate(s.expires_at)}</Td>
              <Td style={{fontSize:11,color:C.danger}}>{s.cancelled_at?fmtDate(s.cancelled_at):"-"}</Td>
            </tr>
          )}/>
      </Section>

      <Section title="Copy trader subscriptions">
        <PagedTable data={copySubs} pageSize={10} searchKeys={["follower_email","provider_email","follower_account","provider_account"]}
          columns={[{label:"Follower"},{label:"Account"},{label:"Provider"},{label:"Account"},{label:"Lot multiplier"},{label:"Status"},{label:"Since"}]}
          renderRow={(s,i)=>(
            <tr key={i} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
              <Td style={{fontSize:11,color:C.muted}}>{s.follower_email||"-"}</Td>
              <Td style={{fontFamily:"monospace",fontSize:11,color:C.accent}}>{s.follower_account||"-"}</Td>
              <Td style={{fontSize:11,color:C.muted}}>{s.provider_email||"-"}</Td>
              <Td style={{fontFamily:"monospace",fontSize:11,color:C.accent}}>{s.provider_account||"-"}</Td>
              <Td style={{color:C.warn,fontWeight:600}}>{s.lot_multiplier}x</Td>
              <Td>{statusPill(s.status)}</Td>
              <Td style={{fontSize:11,color:C.muted}}>{fmtDate(s.created_at)}</Td>
            </tr>
          )}/>
      </Section>
    </div>
  );
};

// ─── User Growth ──────────────────────────────────────────────────────────────
const TabUserGrowth=({growth,cashflow})=>{
  const monthly=growth?.monthly||[];
  const weekly=growth?.weekly||[];
  const maxMonthly=Math.max(...monthly.map(r=>r.signups),1);
  const maxWeekly=Math.max(...weekly.map(r=>r.signups),1);
  return (
    <div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,minmax(0,1fr))",gap:10,marginBottom:16}}>
        <MetricCard label="Total users" value={cashflow?.user_growth?.total??"-"} color={C.accent}/>
        <MetricCard label="New this week" value={cashflow?.user_growth?.weekly??"-"} color={C.success}/>
        <MetricCard label="New this month" value={cashflow?.user_growth?.monthly??"-"} color={C.warn}/>
        <MetricCard label="New this year" value={cashflow?.user_growth?.yearly??"-"} color={C.purple}/>
      </div>

      <Section title="Monthly signups — last 12 months">
        <div style={{padding:"16px 20px"}}>
          {monthly.length===0&&<div style={{color:C.muted,fontSize:13,textAlign:"center",padding:"20px 0"}}>No data yet</div>}
          {monthly.map((r,i)=>(
            <div key={i} style={{display:"flex",alignItems:"center",gap:12,marginBottom:10}}>
              <div style={{fontSize:12,color:C.muted,width:70,flexShrink:0}}>{r.month}</div>
              <div style={{flex:1,background:C.elevated,borderRadius:4,overflow:"hidden",height:20}}>
                <div style={{width:`${(r.signups/maxMonthly)*100}%`,height:"100%",background:C.accent,borderRadius:4,minWidth:r.signups>0?4:0}}/>
              </div>
              <div style={{fontSize:12,fontWeight:700,color:C.text,width:30,textAlign:"right"}}>{r.signups}</div>
              <div style={{display:"flex",gap:6,width:160,flexShrink:0}}>
                {r.traders>0&&<span style={{fontSize:10,background:C.success+"22",color:C.success,padding:"1px 6px",borderRadius:4}}>{r.traders}T</span>}
                {r.analysts>0&&<span style={{fontSize:10,background:C.warn+"22",color:C.warn,padding:"1px 6px",borderRadius:4}}>{r.analysts}A</span>}
                {r.investors>0&&<span style={{fontSize:10,background:C.accent+"22",color:C.accent,padding:"1px 6px",borderRadius:4}}>{r.investors}I</span>}
              </div>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Weekly signups — last 8 weeks">
        <div style={{padding:"16px 20px"}}>
          {weekly.length===0&&<div style={{color:C.muted,fontSize:13,textAlign:"center",padding:"20px 0"}}>No data yet</div>}
          {weekly.map((r,i)=>(
            <div key={i} style={{display:"flex",alignItems:"center",gap:12,marginBottom:10}}>
              <div style={{fontSize:12,color:C.muted,width:90,flexShrink:0}}>w/{r.week?.slice(5,10)}</div>
              <div style={{flex:1,background:C.elevated,borderRadius:4,overflow:"hidden",height:20}}>
                <div style={{width:`${(r.signups/maxWeekly)*100}%`,height:"100%",background:C.success,borderRadius:4,minWidth:r.signups>0?4:0}}/>
              </div>
              <div style={{fontSize:12,fontWeight:700,color:C.text,width:30,textAlign:"right"}}>{r.signups}</div>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
};

// ─── Fee Report ──────────────────────────────────────────────────────────────
const TabFeeReport=({brokers,reloadAccounts})=>{
  const today=new Date().toISOString().slice(0,10);
  const monthAgo=new Date(Date.now()-30*86400000).toISOString().slice(0,10);
  const [from,setFrom]=useState(monthAgo);
  const [to,setTo]=useState(today);
  const [data,setData]=useState([]);
  const [loading,setLoading]=useState(false);
  const [detail,setDetails]=useState(null);
  const [editIB,setEditIB]=useState(null);
  const [ibForm,setIBForm]=useState({uses_platform_ib:false,ib_broker_id:""});

  const load=async()=>{
    setLoading(true);
    try{const r=await adminAPI.getFeeReport(from,to);setData(r.data||[]);}
    catch(e){alert(e.message);}
    setLoading(false);
  };
  const loadDetails=async(accountId)=>{
    try{const r=await adminAPI.getFeeReportAccount(accountId,from,to);setDetails(r);}
    catch(e){alert(e.message);}
  };
  const saveIB=async()=>{
    try{
      await adminAPI.updateIBStatus(editIB.account_id, ibForm.uses_platform_ib, ibForm.ib_broker_id||null);
      setEditIB(null); load();
    }catch(e){alert(e.message);}
  };

  useEffect(()=>{load();},[]);

  const totalPlatform=data.reduce((s,r)=>s+r.platform_gets,0);
  const totalTrader=data.reduce((s,r)=>s+r.trader_gets,0);
  const totalAffiliate=data.reduce((s,r)=>s+r.affiliate_gets,0);
  const totalRebate=data.reduce((s,r)=>s+r.gross_rebate,0);
  const totalPerfFee=data.reduce((s,r)=>s+r.perf_fee_total,0);

  return (
    <div>
      <div style={{display:"flex",gap:12,alignItems:"center",marginBottom:16,background:C.elevated,border:`1px solid ${C.border}`,borderRadius:10,padding:"12px 16px"}}>
        <div style={{fontSize:12,color:C.muted}}>Period:</div>
        <input type="date" value={from} onChange={e=>setFrom(e.target.value)}
          style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:6,padding:"5px 10px",fontSize:12,color:C.text}}/>
        <div style={{fontSize:12,color:C.muted}}>to</div>
        <input type="date" value={to} onChange={e=>setTo(e.target.value)}
          style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:6,padding:"5px 10px",fontSize:12,color:C.text}}/>
        <Btn primary onClick={load}>{loading?"Loading...":"Generate Report"}</Btn>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(5,minmax(0,1fr))",gap:10,marginBottom:16}}>
        <MetricCard label="Total platform revenue" value={"$"+totalPlatform.toFixed(2)} color={C.success}/>
        <MetricCard label="Total trader payout" value={"$"+totalTrader.toFixed(2)} color={C.accent}/>
        <MetricCard label="Total affiliate payout" value={"$"+totalAffiliate.toFixed(2)} color={C.warn}/>
        <MetricCard label="Gross rebate (broker)" value={"$"+totalRebate.toFixed(2)} color={C.purple}/>
        <MetricCard label="Performance fees" value={"$"+totalPerfFee.toFixed(2)} color="#f472b6"/>
      </div>

      <Section title={`Fee report per account (${data.length}) — ${from} to ${to}`}>
        <PagedTable data={data} pageSize={10} searchKeys={["account_number","broker","user_email"]}
          columns={[{label:"Account"},{label:"Owner"},{label:"IB"},{label:"Lots"},{label:"Gross rebate"},{label:"Perf. fee"},{label:"Trader gets"},{label:"Platform gets"},{label:"Affiliate"},{label:"Tier"},{label:""}]}
          renderRow={(r,i)=>(
            <tr key={i} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
              <Td style={{fontWeight:600,fontFamily:"monospace",color:C.accent,fontSize:11}}>{r.account_number}</Td>
              <Td style={{fontSize:11,color:C.muted}}>{r.user_email}</Td>
              <Td>
                {r.uses_platform_ib
                  ?<span style={{background:C.success+"22",color:C.success,fontSize:10,padding:"2px 6px",borderRadius:4,fontWeight:600}}>IB </span>
                  :<span style={{background:C.danger+"22",color:C.danger,fontSize:10,padding:"2px 6px",borderRadius:4}}>Non-IB</span>}
              </Td>
              <Td style={{color:C.text}}>{Number(r.total_lots).toFixed(2)}</Td>
              <Td style={{color:C.purple,fontWeight:600}}>${Number(r.gross_rebate).toFixed(2)}</Td>
              <Td style={{color:"#f472b6",fontWeight:600}}>${Number(r.perf_fee_total).toFixed(2)}</Td>
              <Td style={{color:C.accent,fontWeight:700}}>${Number(r.trader_gets).toFixed(2)}</Td>
              <Td style={{color:C.success,fontWeight:700}}>${Number(r.platform_gets).toFixed(2)}</Td>
              <Td style={{color:C.warn}}>${Number(r.affiliate_gets).toFixed(2)}</Td>
              <Td><span style={{fontSize:10,color:C.muted}}>{r.affiliate_tier||"None"}</span></Td>
              <Td>
                <div style={{display:"flex",gap:4}}>
                  <Btn small onClick={()=>loadDetails(r.account_id)}>Details</Btn>
                  <Btn small onClick={()=>{setEditIB(r);setIBForm({uses_platform_ib:r.uses_platform_ib,ib_broker_id:""});}}>IB</Btn>
                </div>
              </Td>
            </tr>
          )}/>
      </Section>

      {detail && (
        <Capital title={`Details — ${detail.account_number} (${detail.broker})`} onClose={()=>setDetails(null)}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:16}}>
            {[
              ["Period",`${detail.period_from} → ${detail.period_to}`],
              ["IB Status",detail.uses_platform_ib?"Pakai IB ":"Non-IB"],
              ["IB Broker",detail.ib_broker_name||"-"],
              ["Affiliate tier",detail.affiliate_tier||"None"],
              ["Total lots",Number(detail.total_lots).toFixed(2)],
              ["Total profit","$"+Number(detail.total_profit).toFixed(2)],
              ["Peak equity (HWM)","$"+Number(detail.peak_equity).toFixed(2)],
              ["Current equity","$"+Number(detail.current_equity).toFixed(2)],
              ["New profit above HWM","$"+Number(detail.new_profit_above_hwm).toFixed(2)],
              ["Broker pays/lot","$"+Number(detail.broker_pays_per_lot).toFixed(2)],
              ["Gross rebate","$"+Number(detail.gross_rebate).toFixed(2)],
              ["Perf fee ("+detail.perf_fee_pct+"%)","$"+Number(detail.perf_fee_total).toFixed(2)],
            ].map(([k,v],i)=>(
              <div key={i} style={{background:C.elevated,borderRadius:6,padding:"8px 10px"}}>
                <div style={{fontSize:10,color:C.muted,marginBottom:2}}>{k}</div>
                <div style={{fontSize:13,fontWeight:600,color:C.text}}>{v}</div>
              </div>
            ))}
          </div>
          <div style={{background:C.elevated,borderRadius:8,padding:"12px 14px"}}>
            <div style={{fontSize:11,color:C.muted,marginBottom:8,fontWeight:600}}>SPLIT BREAKDOWN</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:11,color:C.muted}}>Trader gets</div>
                <div style={{fontSize:18,fontWeight:800,color:C.accent}}>${Number(detail.trader_gets).toFixed(2)}</div>
                <div style={{fontSize:10,color:C.muted}}>{detail.trader_share_pct}%</div>
              </div>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:11,color:C.muted}}>Platform gets</div>
                <div style={{fontSize:18,fontWeight:800,color:C.success}}>${Number(detail.platform_gets).toFixed(2)}</div>
                <div style={{fontSize:10,color:C.muted}}>{(detail.platform_max_pct-detail.affiliate_share_pct).toFixed(1)}%</div>
              </div>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:11,color:C.muted}}>Affiliate gets</div>
                <div style={{fontSize:18,fontWeight:800,color:C.warn}}>${Number(detail.affiliate_gets).toFixed(2)}</div>
                <div style={{fontSize:10,color:C.muted}}>{detail.affiliate_share_pct}%</div>
              </div>
            </div>
          </div>
        </Capital>
      )}

      {editIB && (
        <Capital title={`Set IB status — ${editIB.account_number}`} onClose={()=>setEditIB(null)}>
          <div style={{background:C.elevated,borderRadius:8,padding:"12px",marginBottom:16,fontSize:12,color:C.muted}}>
            Toggle IB status untuk testing perhitungan fee. Perubahan ini akan mempengaruhi split rebate akun ini.
          </div>
          <div style={{marginBottom:16,display:"flex",alignItems:"center",gap:10}}>
            <input type="checkbox" id="ib_toggle" checked={ibForm.uses_platform_ib}
              onChange={e=>setIBForm({...ibForm,uses_platform_ib:e.target.checked})}/>
            <label htmlFor="ib_toggle" style={{fontSize:13,color:C.text,fontWeight:600}}>
              Account ini dibuka via IB CrunchAlpha
            </label>
          </div>
          {ibForm.uses_platform_ib && (
            <div style={{marginBottom:16}}>
              <label style={{fontSize:11,color:C.muted,display:"block",marginBottom:4,fontWeight:600,textTransform:"uppercase"}}>IB Broker</label>
              <select value={ibForm.ib_broker_id} onChange={e=>setIBForm({...ibForm,ib_broker_id:e.target.value})}
                style={{width:"100%",padding:"8px 10px",border:`1px solid ${C.border}`,borderRadius:6,fontSize:13,background:C.elevated,color:C.text}}>
                <option value="">— Select broker —</option>
                {brokers.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
              </select>
            </div>
          )}
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <Btn onClick={()=>setEditIB(null)}>Cancel</Btn>
            <Btn primary onClick={saveIB}>Save & Recalculate</Btn>
          </div>
        </Capital>
      )}
    </div>
  );
};

// ─── Fee Overrides ────────────────────────────────────────────────────────────
// ─── Multi-Fee Settings (Fee Engine V2) ──────────────────────────────────────
const FEE_TYPE_COLOR={performance:C.warn,subscription:C.accent,volume:"var(--success)",management:"#f472b6",platform:C.success,joining:C.muted};

// ─── Fee params editor — form angka biasa per fee_type, GANTIKAN textarea
// JSON mentah (tidak ramah non-teknis). Skema field per fee_type, sesuai
// nama key yang sudah dipakai backend (params JSONB di fee_rules).
const FEE_PARAM_SCHEMA = {
  performance: [
    {key:"trader_pct",label:"Trader Fee %",placeholder:"25"},
    {key:"analyst_pct",label:"Analyst Fee %",placeholder:"25"},
    {key:"trader_split_pct",label:"Split ke Trader %",placeholder:"80"},
  ],
  volume: [
    {key:"per_lot_usd",label:"Fee per Lot (USD)",placeholder:"0.5"},
    {key:"trader_split_pct",label:"Split ke Trader %",placeholder:"80"},
  ],
  management: [
    {key:"annual_rate_pct",label:"Rate Tahunan %",placeholder:"3.65"},
    {key:"trader_split_pct",label:"Split ke Trader %",placeholder:"80"},
  ],
  platform: [
    {key:"flat_usd_per_month",label:"Flat Fee per Bulan (USD)",placeholder:"2"},
  ],
  joining: [
    {key:"flat_usd",label:"Flat Fee Sekali Bayar (USD)",placeholder:"5"},
  ],
  subscription: [
    {key:"flat_usd",label:"Flat Fee per Bulan (USD)",placeholder:"20"},
  ],
};

// Ringkas params jadi kalimat manusia utk preview kartu - GANTIKAN
// JSON.stringify mentah. Fallback ke "Belum diatur" kalau kosong.
const formatFeeParams=(feeTypeId,params)=>{
  if(!params || Object.keys(params).length===0) return "Belum diatur";
  const p = params;
  switch(feeTypeId){
    case "performance":
      return `${p.trader_pct??"-"}% trader, ${p.analyst_pct??"-"}% analyst (split ${p.trader_split_pct??"-"}% ke trader)`;
    case "volume":
      return `$${p.per_lot_usd??"-"} per lot (split ${p.trader_split_pct??"-"}% ke trader)`;
    case "management":
      return `${p.annual_rate_pct??"-"}% per tahun (split ${p.trader_split_pct??"-"}% ke trader)`;
    case "platform":
      return `$${p.flat_usd_per_month??"-"} per bulan`;
    case "joining":
      return `$${p.flat_usd??"-"} sekali bayar`;
    case "subscription":
      return `$${p.flat_usd??"-"} per bulan`;
    default:
      return JSON.stringify(p);
  }
};

const FeeParamsEditor=({feeTypeId,params,onChange})=>{
  const schema = FEE_PARAM_SCHEMA[feeTypeId] || [];
  if(schema.length===0){
    return <div style={{fontSize:12,color:C.muted}}>Tidak ada parameter untuk jenis fee ini.</div>;
  }
  const setField=(key,val)=>{
    const num = val===""?"":parseFloat(val);
    onChange({...params, [key]: isNaN(num)?val:num});
  };
  return (
    <div>
      {schema.map(f=>(
        <div key={f.key} style={{marginBottom:12}}>
          <label style={{fontSize:11,color:C.muted,display:"block",marginBottom:4,fontWeight:600,textTransform:"uppercase"}}>{f.label}</label>
          <input type="number" step="any" placeholder={f.placeholder}
            value={params?.[f.key] ?? ""}
            onChange={e=>setField(f.key,e.target.value)}
            style={{width:"100%",padding:"8px 10px",border:`1px solid ${C.border}`,borderRadius:6,fontSize:13,background:C.elevated,color:C.text}}/>
        </div>
      ))}
    </div>
  );
};

const TabMultiFee=({feeRules,reload,onToggle,onSaveParams})=>{
  const [editing,setEditing]=useState(null);
  const [paramsObj,setParamsObj]=useState({});
  const [saving,setSaving]=useState(false);

  const toggle=async(rule)=>{
    try{
      if(onToggle){ await onToggle(rule); }
      else{ await adminAPI.updateFeeRule(rule.id,{is_enabled:!rule.is_enabled}); }
      reload();
    }catch(e){alert(e.message);}
  };

  const openEdit=(rule)=>{
    setEditing(rule);
    setParamsObj(rule.params||{});
  };

  const saveParams=async()=>{
    setSaving(true);
    try{
      if(onSaveParams){ await onSaveParams(editing,paramsObj); }
      else{ await adminAPI.updateFeeRule(editing.id,{params:paramsObj}); }
      setEditing(null);
      reload();
    }catch(e){alert(e.message);}
    setSaving(false);
  };

  return (
    <div>
      <Section title={`Fee types (${feeRules.length})`}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:12}}>
          {feeRules.map(r=>(
            <div key={r.id} style={{background:C.elevated,border:`1px solid ${C.border}`,borderRadius:10,padding:"16px 18px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                <div>
                  <div style={{fontSize:14,fontWeight:800,color:FEE_TYPE_COLOR[r.fee_type_id]||C.accent}}>{r.label}</div>
                  <div style={{fontSize:11,color:C.muted,marginTop:2}}>{r.trigger_model}</div>
                </div>
                <button onClick={()=>toggle(r)} style={{
                  padding:"4px 12px",fontSize:11,fontWeight:700,borderRadius:20,cursor:"pointer",
                  border:`1px solid ${r.is_enabled?C.success:C.border}`,
                  background:r.is_enabled?C.success+"22":"transparent",
                  color:r.is_enabled?C.success:C.muted
                }}>{r.is_enabled?"ON":"OFF"}</button>
              </div>
              {r.description && <div style={{fontSize:11,color:C.muted,marginBottom:10}}>{r.description}</div>}
              <div style={{fontSize:11,color:C.muted,fontFamily:"monospace",background:C.bg,borderRadius:6,padding:"8px 10px",marginBottom:10,maxHeight:80,overflow:"auto"}}>
                {formatFeeParams(r.fee_type_id, r.params)}
              </div>
              <Btn small onClick={()=>openEdit(r)}>Atur Fee</Btn>
            </div>
          ))}
        </div>
      </Section>
      {editing&&(
        <Capital title={`Atur ${editing.label}`} onClose={()=>setEditing(null)}>
          <FeeParamsEditor feeTypeId={editing.fee_type_id} params={paramsObj} onChange={setParamsObj}/>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:12}}>
            <Btn onClick={()=>setEditing(null)}>Cancel</Btn>
            <Btn primary disabled={saving} onClick={saveParams}>{saving?"Saving...":"Save"}</Btn>
          </div>
        </Capital>
      )}
    </div>
  );
};

const TabFees=({overrides,reload})=>{
  const [showAdd,setShowAdd]=useState(false);
  const [defaults,setDefaults]=useState({});
  const emptyForm={user_email:"",performance_fee:"",subscription_fee_monthly:"",rebate_share_pct:"",affiliate_commission_pct:"",note:""};
  const [form,setForm]=useState(emptyForm);

  useEffect(()=>{
    fetch("/api/admin/default-fees",{headers:{Authorization:`Bearer ${localStorage.getItem("access_token")||localStorage.getItem("token")||""}`}})
      .then(r=>r.json()).then(d=>{ if(d.data) setDefaults(d.data); });
  },[]);

  const save=async()=>{
    try{
      await adminAPI.upsertFeeOverride({
        user_email:form.user_email,
        performance_fee:form.performance_fee?parseFloat(form.performance_fee):null,
        subscription_fee_monthly:form.subscription_fee_monthly?parseFloat(form.subscription_fee_monthly):null,
        rebate_share_pct:form.rebate_share_pct?parseFloat(form.rebate_share_pct):null,
        affiliate_commission_pct:form.affiliate_commission_pct?parseFloat(form.affiliate_commission_pct):null,
        note:form.note||null
      });
      setShowAdd(false);setForm(emptyForm);reload();
    }catch(e){alert(e.message);}
  };
  const del=async(o)=>{
    if(!window.confirm(`Remove override for ${o.user_email}?`))return;
    try{await adminAPI.deleteFeeOverride(o.id);reload();}catch(e){alert(e.message);}
  };
  const f=(k)=>({value:form[k]??"",onChange:e=>setForm({...form,[k]:e.target.value})});
  const d=defaults;
  return (
    <div>
      <div style={{background:C.elevated,border:`1px solid ${C.border}`,borderRadius:10,padding:"16px 18px",marginBottom:16,display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:12}}>
        <div><div style={{fontSize:11,color:C.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.04em"}}>Trader Perf. Fee</div><div style={{fontSize:20,fontWeight:800,color:C.warn}}>{d.trader_performance_fee_pct??"-"}%</div><div style={{fontSize:11,color:C.muted}}>of copy trade profit</div></div>
        <div><div style={{fontSize:11,color:C.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.04em"}}>Analyst Perf. Fee</div><div style={{fontSize:20,fontWeight:800,color:C.warn}}>{d.analyst_performance_fee_pct??"-"}%</div><div style={{fontSize:11,color:C.muted}}>of signal profit</div></div>
        <div><div style={{fontSize:11,color:C.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.04em"}}>Trader Sub. Fee</div><div style={{fontSize:20,fontWeight:800,color:C.accent}}>${d.trader_subscription_fee_usd??"-"}/mo</div><div style={{fontSize:11,color:C.muted}}>per trader subscription</div></div>
        <div><div style={{fontSize:11,color:C.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.04em"}}>Analyst Sub. Fee</div><div style={{fontSize:20,fontWeight:800,color:C.accent}}>${d.analyst_subscription_fee_usd??"-"}/mo</div><div style={{fontSize:11,color:C.muted}}>per analyst subscription</div></div>
        <div><div style={{fontSize:11,color:C.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.04em"}}>Investor Rebate</div><div style={{fontSize:20,fontWeight:800,color:"var(--success)"}}>{d.rebate_investor_investor_pct??"-"}%</div><div style={{fontSize:11,color:C.muted}}>investor rebate share</div></div>
        <div><div style={{fontSize:11,color:C.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.04em"}}>Affiliate Commission</div><div style={{fontSize:20,fontWeight:800,color:C.success}}>{d.affiliate_flat_pct??"-"}%</div><div style={{fontSize:11,color:C.muted}}>flat affiliate rate</div></div>
      </div>
      <Section title={`Premium overrides (${overrides.length})`} action={<Btn onClick={()=>setShowAdd(true)}>+ Add override</Btn>}>
        <PagedTable data={overrides} pageSize={10} searchKeys={["user_email","user_name","note"]}
          columns={[{label:"Email"},{label:"Name"},{label:"Perf. fee"},{label:"Sub. fee/mo"},{label:"Rebate %"},{label:"Affiliate %"},{label:"Note"},{label:"Since"},{label:"",w:70}]}
          renderRow={(o,i)=>(
            <tr key={i} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
              <Td style={{fontSize:11}}>{o.user_email}</Td>
              <Td>{o.user_name||"-"}</Td>
              <Td style={{color:C.success,fontWeight:700}}>{o.performance_fee!=null?o.performance_fee+"%":"-"}</Td>
              <Td style={{color:C.success,fontWeight:700}}>{o.subscription_fee_monthly!=null?"$"+o.subscription_fee_monthly+"/mo":"-"}</Td>
              <Td style={{color:"var(--success)",fontWeight:700}}>{o.rebate_share_pct!=null?o.rebate_share_pct+"%":"-"}</Td>
              <Td style={{color:C.accent,fontWeight:700}}>{o.affiliate_commission_pct!=null?o.affiliate_commission_pct+"%":"-"}</Td>
              <Td style={{fontSize:11,color:C.muted}}>{o.note||"-"}</Td>
              <Td style={{fontSize:11,color:C.muted}}>{fmtDate(o.created_at)}</Td>
              <Td><Btn small danger onClick={()=>del(o)}>Remove</Btn></Td>
            </tr>
          )}/>
      </Section>
      {showAdd&&(
        <Capital title="Add fee override" onClose={()=>setShowAdd(false)}>
          <Input label="User email *" {...f("user_email")} placeholder="user@crunchalpha.com"/>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 12px"}}>
            <Input label="Performance fee (%)" type="number" {...f("performance_fee")} placeholder={d.trader_performance_fee_pct??25}/>
            <Input label="Subscription fee/mo ($)" type="number" {...f("subscription_fee_monthly")} placeholder="0"/>
            <Input label="Rebate share (%)" type="number" {...f("rebate_share_pct")} placeholder={d.rebate_investor_investor_pct??25}/>
            <Input label="Affiliate commission (%)" type="number" {...f("affiliate_commission_pct")} placeholder={d.affiliate_flat_pct??10}/>
          </div>
          <Input label="Note" {...f("note")} placeholder="VIP user - special deal"/>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:4}}>
            <Btn onClick={()=>setShowAdd(false)}>Cancel</Btn>
            <Btn primary onClick={save}>Save</Btn>
          </div>
        </Capital>
      )}
    </div>
  );
};

// ─── Platform Config ─────────────────────────────────────────────────────────
const RoleFeesPanel=({role,items,splits,fmtVal,setEditingFee,setFeeVal,SplitBar})=>{
  const [subTier,setSubTier]=useState("basic");
  const subColor={"basic":"var(--accent)","premium":"var(--purple,#a78bfa)"};
  const perfItems=items.filter(f=>!f.key.includes("subscription_"));
  const subBasicItems=items.filter(f=>f.key.includes("subscription_basic_"));
  const subPremiumItems=items.filter(f=>f.key.includes("subscription_premium_"));
  const activeTierItems=subTier==="basic"?subBasicItems:subPremiumItems;
  const getSubSplits=(tierItems)=>{
    const get=(k)=>Number(tierItems.find(f=>f.key===k)?.value||0);
    const shareK=role==="trader"?`trader_subscription_${subTier}_trader_pct`:`analyst_subscription_${subTier}_analyst_pct`;
    const platK=`${role}_subscription_${subTier}_platform_pct`;
    const affK=`${role}_subscription_${subTier}_affiliate_pct`;
    const roleColor=role==="trader"?C.success:C.warn;
    const affColor=role==="trader"?C.warn:"#f472b6";
    return [{label:role==="trader"?"Trader":"Analyst",color:roleColor,v:get(shareK)},{label:"Platform",color:C.accent,v:get(platK)},{label:"Affiliate (max)",color:affColor,v:get(affK)}];
  };
  const catColor=role==="trader"?C.success:C.warn;
  const catLabel=role==="trader"?"Trader Fees":"Analyst Fees";
  return (
    <div>
      <Section title={catLabel+" — Performance Fee"}>
        <SplitBar splits={splits}/>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead><tr><Th>Setting</Th><Th>Description</Th><Th>Value</Th><Th w={80}></Th></tr></thead>
          <tbody>
            {perfItems.length===0&&<tr><td colSpan={4} style={{padding:"20px",textAlign:"center",color:C.muted,fontSize:13}}>No config</td></tr>}
            {perfItems.map(f=>(
              <tr key={f.key} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
                <Td style={{fontWeight:600,fontSize:12}}>{f.label}</Td>
                <Td style={{fontSize:11,color:C.muted,maxWidth:300}}>{f.description||"-"}</Td>
                <Td><span style={{fontSize:16,fontWeight:800,color:catColor}}>{fmtVal(f.key,f.value)}</span></Td>
                <Td><Btn small onClick={()=>{setEditingFee(f);setFeeVal(String(f.value));}}>Edit</Btn></Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Section>
      <Section title={catLabel+" — Subscription Fee"}>
        <div style={{display:"flex",gap:6,marginBottom:14}}>
          {["basic","premium"].map(t=>(
            <button key={t} onClick={()=>setSubTier(t)} style={{padding:"4px 16px",fontSize:12,borderRadius:6,cursor:"pointer",fontWeight:subTier===t?700:400,border:`1px solid ${subTier===t?subColor[t]:C.border}`,background:subTier===t?subColor[t]+"33":"transparent",color:subTier===t?subColor[t]:C.muted,textTransform:"capitalize"}}>{t==="basic"?"Basic":"Premium"}</button>
          ))}
        </div>
        <SplitBar splits={getSubSplits(activeTierItems)}/>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead><tr><Th>Setting</Th><Th>Description</Th><Th>Value</Th><Th w={80}></Th></tr></thead>
          <tbody>
            {activeTierItems.length===0&&<tr><td colSpan={4} style={{padding:"20px",textAlign:"center",color:C.muted,fontSize:13}}>No config</td></tr>}
            {activeTierItems.map(f=>(
              <tr key={f.key} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
                <Td style={{fontWeight:600,fontSize:12}}>{f.label}</Td>
                <Td style={{fontSize:11,color:C.muted,maxWidth:300}}>{f.description||"-"}</Td>
                <Td><span style={{fontSize:16,fontWeight:800,color:subColor[subTier]}}>{fmtVal(f.key,f.value)}</span></Td>
                <Td><Btn small onClick={()=>{setEditingFee(f);setFeeVal(String(f.value));}}>Edit</Btn></Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Section>
    </div>
  );
};

const FeeSettingsPanel=({grouped,reloadConfig})=>{
  const [editingFee,setEditingFee]=useState(null);
  const [feeVal,setFeeVal]=useState("");
  const saveFee=async()=>{
    try{
      await adminAPI.updateFeeConfig(editingFee.key,{value:parseFloat(feeVal)});
      setEditingFee(null); reloadConfig();
    }catch(e){alert(e.message);}
  };
  const FEE_SUBTABS=[
    {key:"trader",label:"Trader Fees",color:C.success},
    {key:"analyst",label:"Analyst Fees",color:C.warn},
    {key:"investor",label:"Investor Fees",color:C.accent},
    {key:"rebate",label:"IB Rebate",color:"var(--success)"},
    {key:"bonus",label:"Bonus Pool",color:"#f472b6"},
    {key:"limit",label:"Limits",color:C.muted},
  ];
  const [feeSubTab,setFeeSubTab]=useState("trader");
  const items=grouped[feeSubTab]||[];

  const SplitBar=({splits})=>(
    <div style={{background:C.elevated,border:`1px solid ${C.border}`,borderRadius:10,padding:"14px 16px",marginBottom:16}}>
      <div style={{fontSize:11,color:C.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.04em",marginBottom:10}}>Split breakdown</div>
      <div style={{display:"flex",gap:0,borderRadius:6,overflow:"hidden",height:28,marginBottom:10}}>
        {splits.filter(s=>s.v>0).map((s,i)=>(
          <div key={i} style={{width:s.v+"%",background:s.color,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:"var(--text-main)",transition:"width 0.3s"}} title={s.label+": "+s.v+"%"}>
            {s.v>=8?s.v+"%":""}
          </div>
        ))}
      </div>
      <div style={{display:"flex",gap:16,flexWrap:"wrap"}}>
        {splits.map((s,i)=>(
          <div key={i} style={{display:"flex",alignItems:"center",gap:6}}>
            <div style={{width:10,height:10,borderRadius:2,background:s.color}}/>
            <span style={{fontSize:11,color:C.muted}}>{s.label}:</span>
            <span style={{fontSize:12,fontWeight:700,color:s.color}}>{s.v}%</span>
          </div>
        ))}
      </div>
    </div>
  );

  const getSplits=(cat,items_)=>{
    const get=(k)=>Number(items_.find(f=>f.key===k)?.value||0);
    if(cat==="trader") return [{label:"Trader",color:C.success,v:get("trader_split_trader_pct")},{label:"Platform",color:C.accent,v:get("trader_split_platform_pct")},{label:"Affiliate (max)",color:C.warn,v:get("trader_split_affiliate_pct")}];
    if(cat==="analyst") return [{label:"Analyst",color:C.warn,v:get("analyst_split_analyst_pct")},{label:"Platform",color:C.accent,v:get("analyst_split_platform_pct")},{label:"Affiliate (max)",color:"#f472b6",v:get("analyst_split_affiliate_pct")}];
    return [];
  };

  const getRebateSplits=(items_)=>{
    const get=(k)=>Number(items_.find(f=>f.key===k)?.value||0);
    return {
      traderIB:[{label:"Trader",color:C.success,v:get("rebate_trader_ib_trader_pct")},{label:"Platform",color:C.accent,v:get("rebate_trader_ib_platform_pct")},{label:"Affiliate (max)",color:C.warn,v:get("rebate_trader_ib_affiliate_max_pct")}],
      investorIB:[{label:"Trader (copy only)",color:C.success,v:get("rebate_investor_trader_pct")},{label:"Investor",color:"#c084fc",v:get("rebate_investor_investor_pct")},{label:"Platform",color:C.accent,v:get("rebate_investor_platform_pct")},{label:"Affiliate (max)",color:C.warn,v:get("rebate_investor_affiliate_max_pct")}],
    };
  };

  const splits=getSplits(feeSubTab,items);
  const rebateSplits=getRebateSplits(grouped["rebate"]||[]);
  const fmtVal=(k,v)=>{
    if((k||"").endsWith("_usd")||(k||"").includes("subscription_fee")||(k||"").includes("access_fee")||(k||"").includes("cap_lite"))return"$"+Number(v).toFixed(2);
    if((k||"").endsWith("_pct")||(k||"").includes("bonus_pool")||(k||"").includes("subscription_basic")||(k||"").includes("subscription_premium"))return Number(v).toFixed(2)+"%";
    return Number(v).toFixed(Number(v)%1===0?0:2);
  };

  return (
    <div>
      <div style={{display:"flex",gap:6,marginBottom:16,flexWrap:"wrap"}}>
        {FEE_SUBTABS.map(st=>(
          <button key={st.key} onClick={()=>setFeeSubTab(st.key)} style={{padding:"5px 14px",fontSize:12,borderRadius:6,cursor:"pointer",fontWeight:feeSubTab===st.key?700:400,border:`1px solid ${feeSubTab===st.key?st.color:C.border}`,background:feeSubTab===st.key?st.color+"22":"transparent",color:feeSubTab===st.key?st.color:C.muted}}>{st.label}</button>
        ))}
      </div>
      {feeSubTab==="rebate" ? (
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
          <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,padding:"14px 16px"}}>
            <div style={{fontSize:13,fontWeight:600,color:"var(--success)",marginBottom:4}}>Trader pakai IB</div>
            <div style={{fontSize:11,color:C.muted,marginBottom:12}}>Rebate dari semua lot trading akun trader sendiri</div>
            <SplitBar splits={rebateSplits.traderIB}/>
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <tbody>
                {(grouped["rebate"]||[]).filter(f=>f.key.includes("rebate_trader_ib")).map(f=>(
                  <tr key={f.key} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
                    <Td style={{fontSize:11,color:C.muted}}>{f.label.replace("Rebate Trader IB — ","")}</Td>
                    <Td style={{fontWeight:700,color:"var(--success)"}}>{Number(f.value).toFixed(1)}%</Td>
                    <Td><Btn small onClick={()=>{setEditingFee(f);setFeeVal(String(f.value));}}>Edit</Btn></Td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{fontSize:11,color:C.danger,marginTop:8,padding:"6px 8px",background:C.danger+"11",borderRadius:6}}>Trader tidak pakai IB = 0 rebate</div>
          </div>
          <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,padding:"14px 16px"}}>
            <div style={{fontSize:13,fontWeight:600,color:"var(--success)",marginBottom:4}}>Investor pakai IB (wajib)</div>
            <div style={{fontSize:11,color:C.muted,marginBottom:12}}>Rebate dari semua lot akun investor. Trader dapat dari lot copy trade ke dia saja.</div>
            <SplitBar splits={rebateSplits.investorIB}/>
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <tbody>
                {(grouped["rebate"]||[]).filter(f=>f.key.includes("rebate_investor")).map(f=>(
                  <tr key={f.key} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
                    <Td style={{fontSize:11,color:C.muted}}>{f.label.replace("Rebate Investor — ","")}</Td>
                    <Td style={{fontWeight:700,color:"var(--success)"}}>{Number(f.value).toFixed(1)}%</Td>
                    <Td><Btn small onClick={()=>{setEditingFee(f);setFeeVal(String(f.value));}}>Edit</Btn></Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div>
          {(feeSubTab==="trader"||feeSubTab==="analyst")
            ? <RoleFeesPanel role={feeSubTab} items={items} splits={splits} fmtVal={fmtVal} setEditingFee={setEditingFee} setFeeVal={setFeeVal} SplitBar={SplitBar}/>
            : (
            <div>
              {splits.length>0&&<SplitBar splits={splits}/>}
              <Section title={getCatLabel(feeSubTab)+" settings"}>
                <table style={{width:"100%",borderCollapse:"collapse"}}>
                  <thead><tr><Th>Setting</Th><Th>Description</Th><Th>Value</Th><Th w={80}></Th></tr></thead>
                  <tbody>
                    {items.length===0&&<tr><td colSpan={4} style={{padding:"20px",textAlign:"center",color:C.muted,fontSize:13}}>No config</td></tr>}
                    {items.map(f=>(
                      <tr key={f.key} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
                        <Td style={{fontWeight:600,fontSize:12}}>{f.label}</Td>
                        <Td style={{fontSize:11,color:C.muted,maxWidth:300}}>{f.description||"-"}</Td>
                        <Td><span style={{fontSize:16,fontWeight:800,color:getCatColor(feeSubTab)}}>{fmtVal(f.key,f.value)}</span></Td>
                        <Td><Btn small onClick={()=>{setEditingFee(f);setFeeVal(String(f.value));}}>Edit</Btn></Td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Section>
              {feeSubTab==="investor"&&(()=>{
                const allItems=[...(grouped["trader"]||[]),...(grouped["analyst"]||[])];
                const get=(k)=>Number(allItems.find(f=>f.key===k)?.value||0);
                const refs=[
                  {label:"Performance Fee — Trader",value:get("trader_performance_fee_pct")+"%",desc:"Dari profit copy trade (auto-follow only)",color:C.success},
                  {label:"Performance Fee — Analyst",value:get("analyst_performance_fee_pct")+"%",desc:"Dari profit signal follow (auto-follow only)",color:C.warn},
                  {label:"Subscription Basic — Trader",value:"$"+get("trader_subscription_basic_fee_usd").toFixed(2)+"/mo",desc:"Per trader yang di-follow (Basic tier)",color:"#60a5fa"},
                  {label:"Subscription Premium — Trader",value:"$"+get("trader_subscription_premium_fee_usd").toFixed(2)+"/mo",desc:"Per trader yang di-follow (Premium tier)",color:"var(--purple,#a78bfa)"},
                  {label:"Subscription Basic — Analyst",value:"$"+get("analyst_subscription_basic_fee_usd").toFixed(2)+"/mo",desc:"Per signal set yang di-follow (Basic tier)",color:"#60a5fa"},
                  {label:"Subscription Premium — Analyst",value:"$"+get("analyst_subscription_premium_fee_usd").toFixed(2)+"/mo",desc:"Per signal set yang di-follow (Premium tier)",color:"var(--purple,#a78bfa)"},
                ];
                return (
                  <Section title="Fees Paid by Investor — Reference">
                    <div style={{fontSize:11,color:C.muted,marginBottom:12,padding:"6px 10px",background:C.accent+"11",borderRadius:6,border:`1px solid ${C.accent}33`}}>
                      Read-only — nilai otomatis mengikuti konfigurasi di Trader Fees & Analyst Fees
                    </div>
                    <table style={{width:"100%",borderCollapse:"collapse"}}>
                      <thead><tr><Th>Fee Type</Th><Th>Description</Th><Th>Amount</Th></tr></thead>
                      <tbody>
                        {refs.map((r,i)=>(
                          <tr key={i} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
                            <Td style={{fontWeight:600,fontSize:12}}>{r.label}</Td>
                            <Td style={{fontSize:11,color:C.muted,maxWidth:300}}>{r.desc}</Td>
                            <Td><span style={{fontSize:16,fontWeight:800,color:r.color}}>{r.value}</span></Td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Section>
                );
              })()}
            </div>
          )}
        </div>
      )}
    {editingFee && (
      <Capital title={`Edit — ${editingFee.label}`} onClose={()=>setEditingFee(null)}>
        <div style={{background:C.elevated,borderRadius:8,padding:"12px 14px",marginBottom:16,fontSize:12,color:C.muted,lineHeight:1.6}}>
          <div style={{fontWeight:600,color:C.text,marginBottom:4}}>{editingFee.label}</div>
          {editingFee.description}
        </div>
        <Input label="New value" type="number" value={feeVal} onChange={e=>setFeeVal(e.target.value)} placeholder={String(editingFee.value)}/>
        <div style={{fontSize:11,color:C.muted,marginBottom:16}}>
          {(()=>{const k=editingFee.key||"";if(k.endsWith("_usd")||k.includes("subscription_fee")||k.includes("access_fee")||k.includes("cap_lite"))return"Unit: USD";if(k.endsWith("_pct")||k.includes("bonus_pool"))return"Unit: % (persen)";return"Unit: angka";})()}
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <Btn onClick={()=>setEditingFee(null)}>Cancel</Btn>
          <Btn primary onClick={saveFee}>Save</Btn>
        </div>
      </Capital>
    )}
  </div>);
};

const CATEGORY_LABEL = {
  trader:"Trader Fees", analyst:"Analyst Fees", investor:"Investor Fees",
  split:"Platform Split", bonus:"Bonus Pool", limit:"Platform Limits", rebate:"IB Rebate"
};
const CATEGORY_COLOR = {
  trader:C.success, analyst:C.warn, investor:C.accent,
  split:"#c084fc", bonus:"#f472b6", limit:C.muted, rebate:"var(--success)"
};
const CATEGORY_ORDER = ["trader","analyst","investor","split","bonus","limit","rebate"];
const getCatLabel = (cat) => CATEGORY_LABEL[cat] || cat;
const getCatColor = (cat) => CATEGORY_COLOR[cat] || C.muted;

const TabPlatformConfig=({feeConfig,affiliateTiers,docs,reloadConfig})=>{
  const [editingFee,setEditingFee]=useState(null);
  const [feeVal,setFeeVal]=useState("");
  const [editingTier,setEditingTier]=useState(null);
  const [tierForm,setTierForm]=useState({});
  const [activeSection,setActiveSection]=useState("fees");

  const saveFee=async()=>{
    try{
      await adminAPI.updateFeeConfig(editingFee.key,{value:parseFloat(feeVal)});
      setEditingFee(null);
      reloadConfig();
    }catch(e){alert(e.message);}
  };

  const saveTier=async()=>{
    try{
      await adminAPI.updateAffiliateTier(editingTier.id,{
        min_active_referrals:parseInt(tierForm.min_active_referrals),
        min_active_subscribers:parseInt(tierForm.min_active_subscribers),
        min_retention_pct:parseFloat(tierForm.min_retention_pct),
        max_churn_pct:parseFloat(tierForm.max_churn_pct),
        min_aum_proxy_usd:parseFloat(tierForm.min_aum_proxy_usd),
        affiliate_share_pct:parseFloat(tierForm.affiliate_share_pct),
      });
      setEditingTier(null); reloadConfig();
    }catch(e){alert(e.message);}
  };

  const grouped = feeConfig.reduce((acc,f)=>{
    if(!acc[f.category]) acc[f.category]=[];
    acc[f.category].push(f);
    return acc;
  },{});

  const tierColor={bronze:"#BA7517",silver:"#888780",gold:"#BA7517",platinum:"#7F77DD"};

  return (
    <div>
      <div style={{display:"flex",gap:8,marginBottom:16}}>
        {["fees","tiers","docs"].map(s=>(
          <button key={s} onClick={()=>setActiveSection(s)} style={{padding:"6px 16px",fontSize:12,border:`1px solid ${activeSection===s?C.accent:C.border}`,borderRadius:6,background:activeSection===s?C.accent+"22":"transparent",color:activeSection===s?C.accent:C.muted,cursor:"pointer",fontWeight:activeSection===s?700:400,textTransform:"capitalize"}}>{s==="fees"?"Fee Settings":s==="tiers"?"Affiliate Tiers":"Business Docs"}</button>
        ))}
      </div>

      {activeSection==="fees" && <FeeSettingsPanel grouped={grouped} reloadConfig={reloadConfig}/>}
      {activeSection==="fees_DISABLED" && (
        <div>
          {(()=>{
            const FEE_SUBTABS=[
              {key:"trader",label:"Trader Fees",color:C.success},
              {key:"analyst",label:"Analyst Fees",color:C.warn},
              {key:"investor",label:"Investor Fees",color:C.accent},
              {key:"rebate",label:"IB Rebate",color:"var(--success)"},
              {key:"bonus",label:"Bonus Pool",color:"#f472b6"},
              {key:"limit",label:"Limits",color:C.muted},
            ];
            const [feeSubTab,setFeeSubTab]=React.useState("trader");
            const items=grouped[feeSubTab]||[];
            const SplitBar=({splits})=>(
              <div style={{background:C.elevated,border:`1px solid ${C.border}`,borderRadius:10,padding:"14px 16px",marginBottom:16}}>
                <div style={{fontSize:11,color:C.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.04em",marginBottom:10}}>Split breakdown</div>
                <div style={{display:"flex",gap:0,borderRadius:6,overflow:"hidden",height:28,marginBottom:10}}>
                  {splits.filter(s=>s.v>0).map((s,i)=>(
                    <div key={i} style={{width:s.v+"%",background:s.color,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:"var(--text-main)",transition:"width 0.3s"}} title={s.label+": "+s.v+"%"}>
                      {s.v>=8?s.v+"%":""}
                    </div>
                  ))}
                </div>
                <div style={{display:"flex",gap:16,flexWrap:"wrap"}}>
                  {splits.map((s,i)=>(
                    <div key={i} style={{display:"flex",alignItems:"center",gap:6}}>
                      <div style={{width:10,height:10,borderRadius:2,background:s.color}}/>
                      <span style={{fontSize:11,color:C.muted}}>{s.label}:</span>
                      <span style={{fontSize:12,fontWeight:700,color:s.color}}>{s.v}%</span>
                    </div>
                  ))}
                </div>
              </div>
            );
            const getSplits=(cat,items_)=>{
              const get=(k)=>Number(items_.find(f=>f.key===k)?.value||0);
              if(cat==="trader") return [{label:"Trader",color:C.success,v:get("trader_split_trader_pct")},{label:"Platform",color:C.accent,v:get("trader_split_platform_pct")},{label:"Affiliate (max)",color:C.warn,v:get("trader_split_affiliate_pct")}];
              if(cat==="analyst") return [{label:"Analyst",color:C.warn,v:get("analyst_split_analyst_pct")},{label:"Platform",color:C.accent,v:get("analyst_split_platform_pct")},{label:"Affiliate (max)",color:"#f472b6",v:get("analyst_split_affiliate_pct")}];
              return [];
            };
            const getRebateSplits=(items_)=>{
              const get=(k)=>Number(items_.find(f=>f.key===k)?.value||0);
              return {
                traderIB:[{label:"Trader",color:C.success,v:get("rebate_trader_ib_trader_pct")},{label:"Platform",color:C.accent,v:get("rebate_trader_ib_platform_pct")},{label:"Affiliate (max)",color:C.warn,v:get("rebate_trader_ib_affiliate_max_pct")}],
                investorIB:[{label:"Trader (copy only)",color:C.success,v:get("rebate_investor_trader_pct")},{label:"Investor",color:"#c084fc",v:get("rebate_investor_investor_pct")},{label:"Platform",color:C.accent,v:get("rebate_investor_platform_pct")},{label:"Affiliate (max)",color:C.warn,v:get("rebate_investor_affiliate_max_pct")}],
              };
            };
            const splits=getSplits(feeSubTab,items);
            const rebateSplits=getRebateSplits(grouped["rebate"]||[]);
            const fmtVal=(k,v)=>{
              if((k||"").endsWith("_usd")||(k||"").includes("subscription_fee")||(k||"").includes("access_fee")||(k||"").includes("cap_lite"))return"$"+Number(v).toFixed(2);
              if((k||"").endsWith("_pct")||(k||"").includes("bonus_pool"))return Number(v).toFixed(2)+"%";
              return Number(v).toFixed(Number(v)%1===0?0:2);
            };
            return (
              <div>
                <div style={{display:"flex",gap:6,marginBottom:16,flexWrap:"wrap"}}>
                  {FEE_SUBTABS.map(st=>(
                    <button key={st.key} onClick={()=>setFeeSubTab(st.key)} style={{padding:"5px 14px",fontSize:12,borderRadius:6,cursor:"pointer",fontWeight:feeSubTab===st.key?700:400,border:`1px solid ${feeSubTab===st.key?st.color:C.border}`,background:feeSubTab===st.key?st.color+"22":"transparent",color:feeSubTab===st.key?st.color:C.muted}}>{st.label}</button>
                  ))}
                </div>
                {feeSubTab==="rebate" ? (
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
                    <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,padding:"14px 16px"}}>
                      <div style={{fontSize:13,fontWeight:600,color:"var(--success)",marginBottom:4}}>Trader pakai IB</div>
                      <div style={{fontSize:11,color:C.muted,marginBottom:12}}>Rebate dari semua lot trading akun trader sendiri</div>
                      <SplitBar splits={rebateSplits.traderIB}/>
                      <table style={{width:"100%",borderCollapse:"collapse"}}>
                        <tbody>
                          {(grouped["rebate"]||[]).filter(f=>f.key.includes("rebate_trader_ib")).map(f=>(
                            <tr key={f.key} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
                              <Td style={{fontSize:11,color:C.muted}}>{f.label.replace("Rebate Trader IB — ","")}</Td>
                              <Td style={{fontWeight:700,color:"var(--success)"}}>{Number(f.value).toFixed(1)}%</Td>
                              <Td><Btn small onClick={()=>{setEditingFee(f);setFeeVal(String(f.value));}}>Edit</Btn></Td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div style={{fontSize:11,color:C.danger,marginTop:8,padding:"6px 8px",background:C.danger+"11",borderRadius:6}}>Trader tidak pakai IB = 0 rebate</div>
                    </div>
                    <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,padding:"14px 16px"}}>
                      <div style={{fontSize:13,fontWeight:600,color:"var(--success)",marginBottom:4}}>Investor pakai IB (wajib)</div>
                      <div style={{fontSize:11,color:C.muted,marginBottom:12}}>Rebate dari semua lot akun investor. Trader dapat dari lot copy trade ke dia saja.</div>
                      <SplitBar splits={rebateSplits.investorIB}/>
                      <table style={{width:"100%",borderCollapse:"collapse"}}>
                        <tbody>
                          {(grouped["rebate"]||[]).filter(f=>f.key.includes("rebate_investor")).map(f=>(
                            <tr key={f.key} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
                              <Td style={{fontSize:11,color:C.muted}}>{f.label.replace("Rebate Investor — ","")}</Td>
                              <Td style={{fontWeight:700,color:"var(--success)"}}>{Number(f.value).toFixed(1)}%</Td>
                              <Td><Btn small onClick={()=>{setEditingFee(f);setFeeVal(String(f.value));}}>Edit</Btn></Td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div>
                    {splits.length>0&&<SplitBar splits={splits}/>}
                    <Section title={getCatLabel(feeSubTab)+" settings"}>
                      <table style={{width:"100%",borderCollapse:"collapse"}}>
                        <thead><tr><Th>Setting</Th><Th>Description</Th><Th>Value</Th><Th w={80}></Th></tr></thead>
                        <tbody>
                          {items.length===0&&<tr><td colSpan={4} style={{padding:"20px",textAlign:"center",color:C.muted,fontSize:13}}>No config</td></tr>}
                          {items.map(f=>(
                            <tr key={f.key} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
                              <Td style={{fontWeight:600,fontSize:12}}>{f.label}</Td>
                              <Td style={{fontSize:11,color:C.muted,maxWidth:300}}>{f.description||"-"}</Td>
                              <Td><span style={{fontSize:16,fontWeight:800,color:getCatColor(f.category)}}>{fmtVal(f.key,f.value)}</span></Td>
                              <Td><Btn small onClick={()=>{setEditingFee(f);setFeeVal(String(f.value));}}>Edit</Btn></Td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </Section>
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      )}

      {activeSection==="tiers" && (
        <div>
          <div style={{background:C.elevated,border:`1px solid ${C.border}`,borderRadius:10,padding:"14px 18px",marginBottom:16,fontSize:12,color:C.muted,lineHeight:1.7}}>
            Tier affiliate ditentukan oleh kualitas referral, bukan jumlah. Parameter: active referrals, active subscribers, retention rate, churn rate, dan estimated AUM proxy (equity × followers). Anti-abuse: fake accounts, circular referrals, one-day churn diblokir otomatis.
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(2,minmax(0,1fr))",gap:16}}>
            {affiliateTiers.map(t=>(
              <div key={t.id} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,overflow:"hidden"}}>
                <div style={{padding:"12px 16px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontSize:15,fontWeight:800,color:tierColor[t.tier_name.toLowerCase()]||C.text}}>{t.tier_name}</span>
                  <Btn small onClick={()=>{setEditingTier(t);setTierForm({...t});}}>Edit</Btn>
                </div>
                <div style={{padding:"12px 16px"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                    <tbody>
                      {[
                        ["Min active referrals", t.min_active_referrals],
                        ["Min active subscribers", t.min_active_subscribers],
                        ["Min retention %", t.min_retention_pct+"%"],
                        ["Max churn %", t.max_churn_pct+"%"],
                        ["Min AUM proxy", "$"+Number(t.min_aum_proxy_usd).toLocaleString()],
                        ["Affiliate share %", t.affiliate_share_pct+"%"],
                      ].map(([label,val],i)=>(
                        <tr key={i}>
                          <td style={{padding:"5px 0",color:C.muted}}>{label}</td>
                          <td style={{padding:"5px 0",textAlign:"right",fontWeight:600,color:C.text}}>{val}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeSection==="docs" && docs?.business_model && (
        <div>
          <div style={{background:C.elevated,border:`1px solid ${C.border}`,borderRadius:10,padding:"16px 20px",marginBottom:16}}>
            <div style={{fontSize:16,fontWeight:800,color:C.text,marginBottom:4}}>{docs.business_model.title}</div>
            <div style={{fontSize:12,color:C.muted}}>Business model & fee rules reference — baca sebelum ubah config</div>
          </div>
          {docs.business_model.sections.map((s,i)=>(
            <Section key={i} title={s.title}>
              <div style={{padding:"14px 16px",fontSize:13,color:C.muted,lineHeight:1.8,whiteSpace:"pre-line"}}>{s.content}</div>
            </Section>
          ))}
        </div>
      )}

      {editingFee && (
        <Capital title={`Edit — ${editingFee.label}`} onClose={()=>setEditingFee(null)}>
          <div style={{background:C.elevated,borderRadius:8,padding:"12px 14px",marginBottom:16,fontSize:12,color:C.muted,lineHeight:1.6}}>
            <div style={{fontWeight:600,color:C.text,marginBottom:4}}>{editingFee.label}</div>
            {editingFee.description}
          </div>
          <Input label="New value" type="number" value={feeVal} onChange={e=>setFeeVal(e.target.value)}
            placeholder={String(editingFee.value)}/>
          <div style={{fontSize:11,color:C.muted,marginBottom:16}}>
            {(()=>{const k=editingFee.key||"";if(k.endsWith("_usd")||k.includes("subscription_fee")||k.includes("access_fee")||k.includes("cap_lite"))return"Unit: USD";if(k.endsWith("_pct")||k.includes("bonus_pool")||k.includes("rebate_share"))return"Unit: % (persen)";return"Unit: angka";})()}
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <Btn onClick={()=>setEditingFee(null)}>Cancel</Btn>
            <Btn primary onClick={saveFee}>Save</Btn>
          </div>
        </Capital>
      )}

      {editingTier && (
        <Capital title={`Edit tier — ${editingTier.tier_name}`} onClose={()=>setEditingTier(null)}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 12px"}}>
            <Input label="Min active referrals" type="number" value={tierForm.min_active_referrals} onChange={e=>setTierForm({...tierForm,min_active_referrals:e.target.value})}/>
            <Input label="Min active subscribers" type="number" value={tierForm.min_active_subscribers} onChange={e=>setTierForm({...tierForm,min_active_subscribers:e.target.value})}/>
            <Input label="Min retention %" type="number" value={tierForm.min_retention_pct} onChange={e=>setTierForm({...tierForm,min_retention_pct:e.target.value})}/>
            <Input label="Max churn %" type="number" value={tierForm.max_churn_pct} onChange={e=>setTierForm({...tierForm,max_churn_pct:e.target.value})}/>
            <Input label="Min AUM proxy ($)" type="number" value={tierForm.min_aum_proxy_usd} onChange={e=>setTierForm({...tierForm,min_aum_proxy_usd:e.target.value})}/>
            <Input label="Affiliate share %" type="number" value={tierForm.affiliate_share_pct} onChange={e=>setTierForm({...tierForm,affiliate_share_pct:e.target.value})}/>
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:4}}>
            <Btn onClick={()=>setEditingTier(null)}>Cancel</Btn>
            <Btn primary onClick={saveTier}>Save</Btn>
          </div>
        </Capital>
      )}
    </div>
  );
};

// ─── Audit Logs ───────────────────────────────────────────────────────────────
const TabAuditLogs=()=>{
  const [logs,setLogs]=useState([]);
  const [total,setTotal]=useState(0);
  const [loading,setLoading]=useState(true);
  const [eventType,setEventType]=useState("");
  const [status,setStatus]=useState("");

  const load=React.useCallback(()=>{
    setLoading(true);
    adminAPI.getAuditLogs({event_type:eventType||undefined, status:status||undefined, limit:200})
      .then(r=>{setLogs(r.data||[]); setTotal(r.total||0);})
      .catch(()=>{})
      .finally(()=>setLoading(false));
  },[eventType,status]);

  useEffect(()=>{load();},[load]);

  const eventTypes=["user","account","broker","fee_override","signal_set","platform_config","system","payment","invoice","subscription"];

  const renderMeta=(metaStr)=>{
    if(!metaStr) return "-";
    try{
      const m=JSON.parse(metaStr);
      const parts=[];
      if(m.target_id) parts.push(`target: ${m.target_id}`);
      if(m.note) parts.push(m.note);
      return parts.join(" — ")||"-";
    }catch{ return metaStr; }
  };

  return (
    <Section title={`Audit logs (${total} total, showing ${logs.length})`}>
      <div style={{display:"flex",gap:8,padding:"10px 14px",borderBottom:`1px solid ${C.border}`,flexWrap:"wrap",alignItems:"center"}}>
        <select value={eventType} onChange={e=>setEventType(e.target.value)}
          style={{background:C.elevated,border:`1px solid ${C.border}`,borderRadius:6,padding:"5px 10px",fontSize:12,color:C.text}}>
          <option value="">All event types</option>
          {eventTypes.map(t=><option key={t} value={t}>{t}</option>)}
        </select>
        <select value={status} onChange={e=>setStatus(e.target.value)}
          style={{background:C.elevated,border:`1px solid ${C.border}`,borderRadius:6,padding:"5px 10px",fontSize:12,color:C.text}}>
          <option value="">All status</option>
          <option value="success">Success</option>
          <option value="failed">Failed</option>
        </select>
        {loading&&<span style={{fontSize:11,color:C.muted}}>Loading...</span>}
      </div>
      <PagedTable data={logs} pageSize={15} searchKeys={["user_email","event_type","event_action"]}
        columns={[{label:"Time"},{label:"User"},{label:"Event type"},{label:"Action"},{label:"Status"},{label:"Details"}]}
        renderRow={(l,i)=>(
          <tr key={i} onMouseEnter={e=>e.currentTarget.style.background=C.elevated} onMouseLeave={e=>e.currentTarget.style.background=""}>
            <Td style={{fontSize:11,color:C.muted,whiteSpace:"nowrap"}}>{l.created_at?.slice(0,19).replace("T"," ")}</Td>
            <Td style={{fontSize:11,color:C.accent}}>{l.user_email||"system"}</Td>
            <Td style={{fontFamily:"monospace",fontSize:11,color:C.warn}}>{l.event_type}</Td>
            <Td style={{fontSize:11,color:C.text}}>{l.event_action||"-"}</Td>
            <Td>{statusPill(l.status||"-")}</Td>
            <Td style={{fontSize:11,color:C.muted}}>{renderMeta(l.metadata)}</Td>
          </tr>
        )}/>
    </Section>
  );
};

// ─── Partner Admin: Marketplace Settings (mode + providers) ───────────────────
const TabPartnerMarketplace=({config,providers,reloadConfig,reloadProviders})=>{
  const [savingMode,setSavingMode]=useState(false);

  const toggleMode=async()=>{
    if(!config) return;
    const newMode=config.marketplaceMode==="open"?"closed":"open";
    setSavingMode(true);
    try{ await adminAPI.updatePartnerAdminConfig({marketplaceMode:newMode}); reloadConfig(); }
    catch(e){alert(e.message);}
    setSavingMode(false);
  };

  const setApproval=async(id,approved)=>{
    try{ await adminAPI.setPartnerAdminProviderApproval(id,approved); reloadProviders(); }
    catch(e){alert(e.message);}
  };

  return (
    <div>
      <Section title="Marketplace Mode">
        <div style={{fontSize:12,color:C.muted,marginBottom:12}}>
          <strong>Open</strong>: anyone can sign up and become a trading strategy provider.<br/>
          <strong>Closed</strong>: new providers need your approval before investors can see and follow their strategies.
        </div>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <span style={{fontSize:13,fontWeight:700,color:C.text}}>
            Current: {config?.marketplaceMode==="closed"?"Closed (approval required)":"Open (marketplace)"}
          </span>
          <Btn primary disabled={savingMode} onClick={toggleMode}>
            {savingMode?"Saving...":`Switch to ${config?.marketplaceMode==="closed"?"Open":"Closed"}`}
          </Btn>
        </div>
      </Section>
      <Section title={`Providers (${providers.length})`}>
        <PagedTable data={providers} pageSize={10} searchKeys={["accountNumber","broker","ownerEmail"]}
          columns={[{label:"Account"},{label:"Broker"},{label:"Owner Email"},{label:"Role"},{label:"Status"},{label:"",w:120}]}
          renderRow={(p,i)=>(
            <tr key={i}>
              <Td>{p.accountNumber}</Td>
              <Td>{p.broker}</Td>
              <Td style={{fontSize:11,color:C.muted}}>{p.ownerEmail}</Td>
              <Td>{p.role}</Td>
              <Td style={{color:p.isApproved?C.success:C.warn}}>{p.isApproved?"Approved":"Pending"}</Td>
              <Td>
                <Btn small onClick={()=>setApproval(p.id,!p.isApproved)}>
                  {p.isApproved?"Revoke":"Approve"}
                </Btn>
              </Td>
            </tr>
          )}/>
      </Section>
    </div>
  );
};

// ─── Partner Admin: Users (read-only) ──────────────────────────────────────────
const TabPartnerUsers=({users}) => (
  <Section title={`Users (${users.length})`}>
    <PagedTable data={users} pageSize={10} searchKeys={["email","name","primary_role"]}
      columns={[{label:"Email"},{label:"Name"},{label:"Role"},{label:"Status"},{label:"Verified"},{label:"Joined"}]}
      renderRow={(u,i)=>(
        <tr key={i}>
          <Td style={{fontSize:11,color:C.muted}}>{u.email}</Td>
          <Td>{u.name||"-"}</Td>
          <Td>{u.primary_role}</Td>
          <Td>{u.status}</Td>
          <Td style={{color:u.email_verified?C.success:C.warn}}>{u.email_verified?"Yes":"No"}</Td>
          <Td style={{fontSize:11,color:C.muted}}>{(u.created_at||"").slice(0,10)}</Td>
        </tr>
      )}/>
  </Section>
);

// ─── Main ─────────────────────────────────────────────────────────────────────
const TabPartnerAccounts=({accounts,action,onCcy,onDisable}) => (
  <Section title={`Trading accounts (${accounts.length})`} action={action}>
    <PagedTable data={accounts} pageSize={10} searchKeys={["account_number","broker","user_email","user_name","nickname"]}
      columns={[{label:"Account #"},{label:"Owner"},{label:"Broker"},{label:"Platform"},{label:"Role"},{label:"Balance"},{label:"Equity"},{label:"Floating"},{label:"EA"},{label:"Status"},{label:"Last sync"},{label:"Actions"}]}
      renderRow={(a,i)=>(
        <tr key={i}>
          <Td style={{fontWeight:600,fontFamily:"monospace",color:C.accent}}>{a.account_number}{a.nickname?<div style={{fontSize:10,color:C.muted,fontWeight:400}}>{a.nickname}</div>:null}</Td>
          <Td><div style={{fontSize:12}}>{a.user_name||"-"}</div><div style={{fontSize:10,color:C.muted}}>{a.user_email}</div></Td>
          <Td style={{fontSize:11,color:C.muted}}>{a.broker}</Td>
          <Td>{rolePill((a.platform||"").toLowerCase())}</Td>
          <Td style={{fontSize:12}}>{a.role}{a.is_approved_provider===false?" · not approved":""}</Td>
          <Td style={{color:C.success,fontWeight:600}}>${fmt(a.balance)}</Td>
          <Td>${fmt(a.equity)}</Td>
          <Td style={{color:(a.floating_profit||0)>=0?C.success:C.danger}}>{a.floating_profit==null?"-":((a.floating_profit<0?"-":"")+"$"+fmt(Math.abs(a.floating_profit)))}</Td>
          <Td style={{color:a.connection_status==="connected"?C.success:C.warn,fontSize:12}}>{a.connection_status||"-"}</Td>
          <Td>{statusPill(a.status)}</Td>
          <Td style={{fontSize:11,color:C.muted}}>{(a.last_sync_at||"").slice(0,16)||"-"}</Td>
          <Td><Btn small onClick={()=>onCcy(a)}>CCY</Btn>{a.status!=="disabled"&&<Btn small danger onClick={()=>onDisable(a)}>Disable</Btn>}</Td>
        </tr>
      )}/>
  </Section>
);

const TabPartnerAccountsManager=({accounts,users,reload}) => {
  const blank={user_id:"",account_number:"",broker:"",platform:"MT5",server:"",currency:"USD",account_role:"provider"};
  const [showAdd,setShowAdd]=useState(false);
  const [form,setForm]=useState(blank);
  const [busy,setBusy]=useState(false);
  const [ccy,setCcy]=useState(null);
  const [ccyVal,setCcyVal]=useState("USD");
  const upd=(k,v)=>setForm(f=>({...f,[k]:v}));
  const doAdd=async()=>{
    if(!form.user_id||!form.account_number.trim()||!form.broker.trim()){alert("Owner, account number and broker are required");return;}
    setBusy(true);
    try{const res=await adminAPI.partnerAdminCreateAccount(form);if(!res.ok){alert(res.error||"Failed");}else{setShowAdd(false);setForm(blank);reload();}}
    catch(e){alert(e.message);}
    setBusy(false);
  };
  const saveCcy=async()=>{
    setBusy(true);
    try{const res=await adminAPI.partnerAdminSetAccountCurrency(ccy.id,ccyVal);if(!res.ok){alert(res.error||"Failed");}else{setCcy(null);reload();}}
    catch(e){alert(e.message);}
    setBusy(false);
  };
  const disable=async(a)=>{
    if(!window.confirm(`Disable account ${a.account_number} (${a.user_email})? Its status will be set to disabled.`))return;
    try{const res=await adminAPI.partnerAdminDisableAccount(a.id);if(!res.ok){alert(res.error||"Failed");return;}}
    catch(e){alert(e.message);return;}
    reload();
  };
  const inp={padding:"8px 10px",borderRadius:6,border:`1px solid ${C.border}`,background:C.elevated,color:C.text,fontSize:12,width:"100%",boxSizing:"border-box"};
  const lab={fontSize:11,color:C.muted,display:"block",marginBottom:4,marginTop:10,fontWeight:600,textTransform:"uppercase"};
  return (
    <>
      <TabPartnerAccounts accounts={accounts} onCcy={(a)=>{setCcy(a);setCcyVal(a.currency==="USC"?"USC":"USD");}} onDisable={disable}/>
      {showAdd&&(
        <Capital title="Add account" onClose={()=>setShowAdd(false)}>
          <label style={lab}>Owner (community member)</label>
          <select value={form.user_id} onChange={e=>upd("user_id",e.target.value)} style={inp}>
            <option value="">Select a member</option>
            {(users||[]).map(u=>(<option key={u.id} value={u.id}>{(u.name||u.email)+" ("+u.email+")"}</option>))}
          </select>
          <label style={lab}>Account number</label>
          <input value={form.account_number} onChange={e=>upd("account_number",e.target.value)} style={inp}/>
          <label style={lab}>Broker</label>
          <input value={form.broker} onChange={e=>upd("broker",e.target.value)} style={inp}/>
          <label style={lab}>Server</label>
          <input value={form.server} onChange={e=>upd("server",e.target.value)} style={inp}/>
          <label style={lab}>Platform</label>
          <select value={form.platform} onChange={e=>upd("platform",e.target.value)} style={inp}><option value="MT5">MT5</option><option value="MT4">MT4</option></select>
          <label style={lab}>Currency</label>
          <select value={form.currency} onChange={e=>upd("currency",e.target.value)} style={inp}><option value="USD">Standard (USD)</option><option value="USC">Cent (USC)</option></select>
          <label style={lab}>Role</label>
          <select value={form.account_role} onChange={e=>upd("account_role",e.target.value)} style={inp}><option value="provider">Provider</option><option value="follower">Follower</option><option value="both">Both</option></select>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:16}}>
            <Btn onClick={()=>setShowAdd(false)}>Cancel</Btn>
            <Btn primary disabled={busy} onClick={doAdd}>Create</Btn>
          </div>
        </Capital>
      )}
      {ccy&&(
        <Capital title={`Set Currency — ${ccy.account_number}`} onClose={()=>setCcy(null)}>
          <div style={{display:"flex",gap:8,marginBottom:16}}>
            {["USD","USC"].map(v=>(
              <button key={v} type="button" onClick={()=>setCcyVal(v)} style={{flex:1,padding:"10px",borderRadius:6,border:`1px solid ${ccyVal===v?C.accent:C.border}`,background:ccyVal===v?"rgba(78,154,241,0.15)":"transparent",color:ccyVal===v?C.accent:C.muted,fontWeight:600,cursor:"pointer"}}>{v==="USD"?"Standard (USD)":"Cent (USC)"}</button>
            ))}
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <Btn onClick={()=>setCcy(null)}>Cancel</Btn>
            <Btn primary disabled={busy} onClick={saveCcy}>Save</Btn>
          </div>
        </Capital>
      )}
    </>
  );
};

const TabPartnerSignalSets=({sets}) => (
  <Section title={`Signal sets (${sets.length})`}>
    <PagedTable data={sets} pageSize={10} searchKeys={["name","analyst_email","analyst_name"]}
      columns={[{label:"Name"},{label:"Analyst"},{label:"Status"},{label:"Signals"},{label:"Win rate"},{label:"Profit factor"},{label:"AlphaScore"},{label:"Created"}]}
      renderRow={(s,i)=>(
        <tr key={i}>
          <Td style={{fontWeight:600}}>{s.name||"-"}</Td>
          <Td><div style={{fontSize:12}}>{s.analyst_name||"-"}</div><div style={{fontSize:10,color:C.muted}}>{s.analyst_email}</div></Td>
          <Td>{statusPill(s.status)}</Td>
          <Td>{fmt(s.total_signals)}</Td>
          <Td>{s.win_rate==null?"-":Number(s.win_rate).toFixed(1)+"%"}</Td>
          <Td>{s.profit_factor==null?"-":Number(s.profit_factor).toFixed(2)}</Td>
          <Td style={{fontWeight:700}}>{(s.alpha_score||0)>0?Number(s.alpha_score).toFixed(1)+" "+(s.alpha_grade||""):"-"}</Td>
          <Td style={{fontSize:11,color:C.muted}}>{(s.created_at||"").slice(0,10)||"-"}</Td>
        </tr>
      )}/>
  </Section>
);

const TabPartnerFeeReport=() => {
  const today=new Date().toISOString().slice(0,10);
  const start=new Date(Date.now()-90*86400000).toISOString().slice(0,10);
  const [from,setFrom]=useState(start);
  const [to,setTo]=useState(today);
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(false);
  const load=async()=>{
    setLoading(true);
    try{const r=await adminAPI.getPartnerAdminFeeReport(from,to);setData(r.data||null);}
    catch(e){alert(e.message);}
    setLoading(false);
  };
  useEffect(()=>{load();},[]);
  const snap=data?.snapshots||{};
  const byType=data?.by_type||[];
  const rows=data?.rows||[];
  const sum=(k)=>byType.reduce((a,x)=>a+(x[k]||0),0);
  const totalFee=(snap.total_fee||0)+sum("amount_usd");
  const traderShare=(snap.trader_share||0)+sum("trader_share");
  const platformShare=(snap.platform_share||0)+sum("platform_share");
  const inp={padding:"6px 10px",borderRadius:6,border:`1px solid ${C.border}`,background:C.elevated,color:C.text,fontSize:12};
  return (
    <div>
      <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:16}}>
        <span style={{fontSize:12,color:C.muted}}>From</span>
        <input type="date" value={from} onChange={e=>setFrom(e.target.value)} style={inp}/>
        <span style={{fontSize:12,color:C.muted}}>To</span>
        <input type="date" value={to} onChange={e=>setTo(e.target.value)} style={inp}/>
        <Btn onClick={load}>{loading?"Loading...":"Apply"}</Btn>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,minmax(0,1fr))",gap:10,marginBottom:16}}>
        <MetricCard label="Total fees" value={fmtUSD(totalFee)} sub="All fee types in range" color={C.accent}/>
        <MetricCard label="Trader/analyst share" value={fmtUSD(traderShare)} sub="Paid out to providers" color={C.success}/>
        <MetricCard label="Platform share" value={fmtUSD(platformShare)} sub="Platform portion" color={C.warn}/>
        <MetricCard label="Performance + subscription" value={fmtUSD((snap.performance_fee||0)+(snap.subscription_fee||0))} sub={`${snap.count||0} monthly snapshots`} color={C.purple}/>
      </div>
      <Section title="By fee type">
        <PagedTable data={byType} pageSize={10} searchKeys={[]}
          columns={[{label:"Fee type"},{label:"Count"},{label:"Amount"},{label:"Trader share"},{label:"Platform share"}]}
          renderRow={(t,i)=>(
            <tr key={i}>
              <Td style={{fontWeight:600}}>{t.fee_type}</Td>
              <Td>{fmt(t.count)}</Td>
              <Td>{fmtUSD(t.amount_usd)}</Td>
              <Td>{fmtUSD(t.trader_share)}</Td>
              <Td>{fmtUSD(t.platform_share)}</Td>
            </tr>
          )}/>
      </Section>
      <div style={{height:16}}/>
      <Section title={`Monthly fee snapshots (${rows.length})`}>
        <PagedTable data={rows} pageSize={10} searchKeys={["follower_account","provider_account"]}
          columns={[{label:"Month"},{label:"Investor account"},{label:"Provider account"},{label:"Performance"},{label:"Subscription"},{label:"Total"},{label:"Trader share"},{label:"Platform share"}]}
          renderRow={(r,i)=>(
            <tr key={i}>
              <Td>{(r.month||"").slice(0,7)}</Td>
              <Td style={{fontFamily:"monospace",color:C.accent}}>{r.follower_account||"-"}</Td>
              <Td style={{fontFamily:"monospace"}}>{r.provider_account||r.set_id||"-"}</Td>
              <Td>{fmtUSD(r.performance_fee)}</Td>
              <Td>{fmtUSD(r.subscription_fee)}</Td>
              <Td style={{fontWeight:600}}>{fmtUSD(r.total_fee)}</Td>
              <Td>{fmtUSD(r.trader_share)}</Td>
              <Td>{fmtUSD(r.platform_share)}</Td>
            </tr>
          )}/>
      </Section>
    </div>
  );
};

const TabPartnerInvoices=() => {
  const [filter,setFilter]=useState("");
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(false);
  const load=async(f)=>{
    setLoading(true);
    try{const r=await adminAPI.getPartnerAdminInvoices(f);setData(r.data||null);}
    catch(e){alert(e.message);}
    setLoading(false);
  };
  useEffect(()=>{load(filter);},[filter]);
  const act=async(r,action)=>{
    const labels={confirm:"Confirm as paid",reject:"Reject",void:"Void"};
    if(!window.confirm(`${labels[action]} invoice ${r.invoice_number||""} (${fmtUSD(r.total_amount)}) for ${r.investor_name||r.investor_email}?`))return;
    let text="";
    if(action==="reject"){const n=window.prompt("Reason for rejection (required, shown to the investor):","");if(n===null)return;if(!n.trim()){alert("Reason is required");return;}text=n;}
    else if(action==="void"){const n=window.prompt("Void note (optional):","");if(n===null)return;text=n;}
    try{const res=await adminAPI.partnerAdminInvoiceAction(r.id,action,text);if(!res.ok){alert(res.error||"Failed");return;}}
    catch(e){alert(e.message);return;}
    load(filter);
  };
  const rows=data?.rows||[];
  const summary=data?.summary||[];
  const sel={padding:"6px 10px",borderRadius:6,border:`1px solid ${C.border}`,background:C.elevated,color:C.text,fontSize:12};
  return (
    <div>
      <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:16}}>
        <span style={{fontSize:12,color:C.muted}}>Status</span>
        <select value={filter} onChange={e=>setFilter(e.target.value)} style={sel}>
          <option value="">All</option>
          <option value="pending">Pending</option>
          <option value="under_review">Under review</option>
          <option value="paid">Paid</option>
          <option value="rejected">Rejected</option>
          <option value="void">Void</option>
        </select>
        {loading&&<span style={{fontSize:12,color:C.muted}}>Loading...</span>}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,minmax(0,1fr))",gap:10,marginBottom:16}}>
        {summary.length===0?<MetricCard label="Invoices" value="0" sub="No invoices yet" small/>:summary.map((s,i)=>(
          <MetricCard key={i} label={s.status||"-"} value={fmtUSD(s.total)} sub={`${s.count} invoice(s)`} small/>
        ))}
      </div>
      <Section title={`Invoices (${rows.length})`}>
        <PagedTable data={rows} pageSize={10} searchKeys={["invoice_number","investor_name","investor_email"]}
          columns={[{label:"Invoice"},{label:"Investor"},{label:"Provider"},{label:"Type"},{label:"Month"},{label:"Total"},{label:"Status"},{label:"Created"},{label:"Actions"}]}
          renderRow={(r,i)=>(
            <tr key={i}>
              <Td style={{fontFamily:"monospace",color:C.accent}}>{r.invoice_number||"-"}</Td>
              <Td><div style={{fontSize:12}}>{r.investor_name||"-"}</div><div style={{fontSize:10,color:C.muted}}>{r.investor_email}</div></Td>
              <Td style={{fontSize:12}}>{r.provider||"-"}</Td>
              <Td style={{fontSize:12}}>{r.invoice_type||"-"}</Td>
              <Td>{(r.billing_month||"").slice(0,7)||"-"}</Td>
              <Td style={{fontWeight:600}}>{fmtUSD(r.total_amount)}</Td>
              <Td>{statusPill(r.status)}</Td>
              <Td style={{fontSize:11,color:C.muted}}>{(r.created_at||"").slice(0,10)||"-"}</Td>
              <Td>{(r.status==="pending"||r.status==="under_review"||r.status==="overdue")&&<Btn small onClick={()=>act(r,"confirm")}>Mark paid</Btn>}{r.status==="pending"&&<Btn small danger onClick={()=>act(r,"void")}>Void</Btn>}{r.status==="under_review"&&<Btn small danger onClick={()=>act(r,"reject")}>Reject</Btn>}</Td>
            </tr>
          )}/>
      </Section>
    </div>
  );
};

const TabPartnerWithdrawals=() => {
  const [status,setStatus]=useState("");
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(false);
  const load=async(s)=>{
    setLoading(true);
    try{const r=await adminAPI.getPartnerAdminWithdrawals(s);setData(r.data||null);}
    catch(e){alert(e.message);}
    setLoading(false);
  };
  const act=async(r,action)=>{
    const labels={approve:"Approve","mark-paid":"Mark as paid",reject:"Reject"};
    if(!window.confirm(`${labels[action]} withdrawal of $${Number(r.amount||0).toFixed(2)} for ${r.user_name||r.email}?`))return;
    let note="";
    if(action==="reject"){const n=window.prompt("Reason for rejection (shown to the user):","");if(n===null)return;note=n;}
    try{const res=await adminAPI.partnerAdminWithdrawalAction(r.id,action,note);if(!res.ok){alert(res.error||"Failed");return;}}
    catch(e){alert(e.message);return;}
    load(status);
  };
  useEffect(()=>{load(status);},[status]);
  const rows=data?.rows||[];
  const summary=data?.summary||[];
  const sel={padding:"6px 10px",borderRadius:6,border:`1px solid ${C.border}`,background:C.elevated,color:C.text,fontSize:12};
  return (
    <div>
      <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:16}}>
        <span style={{fontSize:12,color:C.muted}}>Status</span>
        <select value={status} onChange={e=>setStatus(e.target.value)} style={sel}>
          <option value="">All</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
          <option value="paid">Paid</option>
        </select>
        {loading&&<span style={{fontSize:12,color:C.muted}}>Loading...</span>}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,minmax(0,1fr))",gap:10,marginBottom:16}}>
        {summary.length===0?<MetricCard label="Withdrawals" value="0" sub="No requests yet" small/>:summary.map((s,i)=>(
          <MetricCard key={i} label={s.status||"-"} value={fmtUSD(s.total)} sub={`${s.count} request(s)`} small/>
        ))}
      </div>
      <Section title={`Withdrawal requests (${rows.length})`}>
        <PagedTable data={rows} pageSize={10} searchKeys={["user_name","email"]}
          columns={[{label:"Requested"},{label:"User"},{label:"Role"},{label:"Amount"},{label:"Method"},{label:"Status"},{label:"Processed"},{label:"Actions"}]}
          renderRow={(r,i)=>(
            <tr key={i}>
              <Td style={{fontSize:11,color:C.muted}}>{(r.requested_at||"").slice(0,16)||"-"}</Td>
              <Td><div style={{fontSize:12}}>{r.user_name||"-"}</div><div style={{fontSize:10,color:C.muted}}>{r.email}</div></Td>
              <Td style={{fontSize:12}}>{r.role||"-"}</Td>
              <Td style={{fontWeight:600}}>{fmtUSD(r.amount)}</Td>
              <Td style={{fontSize:12}}>{r.method||"-"}</Td>
              <Td>{statusPill(r.status)}</Td>
              <Td style={{fontSize:11,color:C.muted}}>{(r.processed_at||"").slice(0,16)||"-"}</Td>
              <Td>{r.status==="pending"&&<><Btn small onClick={()=>act(r,"approve")}>Approve</Btn><Btn small danger onClick={()=>act(r,"reject")}>Reject</Btn></>}{r.status==="approved"&&<><Btn small onClick={()=>act(r,"mark-paid")}>Mark paid</Btn><Btn small danger onClick={()=>act(r,"reject")}>Reject</Btn></>}</Td>
            </tr>
          )}/>
      </Section>
    </div>
  );
};

const TabPartnerAffiliates=() => {
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(false);
  const load=async()=>{
    setLoading(true);
    try{const r=await adminAPI.getPartnerAdminAffiliates();setData(r.data||null);}
    catch(e){alert(e.message);}
    setLoading(false);
  };
  useEffect(()=>{load();},[]);
  const rows=data?.rows||[];
  const sm=data?.summary||{};
  return (
    <div>
      {loading&&<div style={{fontSize:12,color:C.muted,marginBottom:10}}>Loading...</div>}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,minmax(0,1fr))",gap:10,marginBottom:16}}>
        <MetricCard label="Affiliates" value={fmt(sm.affiliates||0)} sub="In your community" small/>
        <MetricCard label="Referrals" value={fmt(sm.referrals||0)} sub={`${sm.active_referrals||0} active`} small/>
        <MetricCard label="Paid out" value={fmtUSD(sm.paid_usd||0)} sub="Affiliate payouts" color={C.success} small/>
        <MetricCard label="Pending" value={fmtUSD(sm.pending_usd||0)} sub="Awaiting payout" color={C.warn} small/>
      </div>
      <Section title={`Affiliates (${rows.length})`}>
        <PagedTable data={rows} pageSize={10} searchKeys={["code","email","name"]}
          columns={[{label:"Code"},{label:"Affiliate"},{label:"Role"},{label:"Tier"},{label:"Referrals"},{label:"Active"},{label:"Paid"},{label:"Pending"}]}
          renderRow={(r,i)=>(
            <tr key={i}>
              <Td style={{fontFamily:"monospace",color:C.accent}}>{r.code||"-"}</Td>
              <Td><div style={{fontSize:12}}>{r.name||"-"}</div><div style={{fontSize:10,color:C.muted}}>{r.email}</div></Td>
              <Td style={{fontSize:12}}>{r.role||"-"}</Td>
              <Td style={{fontSize:12}}>{r.tier||"-"}</Td>
              <Td>{fmt(r.total_referrals)}</Td>
              <Td>{fmt(r.active_referrals)}</Td>
              <Td>{fmtUSD(r.total_paid)}</Td>
              <Td>{fmtUSD(r.total_pending)}</Td>
            </tr>
          )}/>
      </Section>
    </div>
  );
};

const AdminDashboard=()=>{
  const [activeTab,setActiveTab]=useState(0);
  const [stats,setStats]=useState({});
  const [cashflow,setCashflow]=useState({});
  const [users,setUsers]=useState([]);
  const [accounts,setAccounts]=useState([]);
  const [signalSets,setSignalSets]=useState([]);
  const [brokers,setBrokers]=useState([]);
  const [overrides,setOverrides]=useState([]);
  const [auditLogs,setAuditLogs]=useState([]);
  const [signalSubs,setSignalSubs]=useState([]);
  const [copySubs,setCopySubs]=useState([]);
  const [growth,setGrowth]=useState({});
  const [feeConfig,setFeeConfig]=useState([]);
  const [feeRules,setFeeRules]=useState([]);
  const [affiliateTiers,setAffiliateTiers]=useState([]);
  const [configDocs,setConfigDocs]=useState(null);
  const [loading,setLoading]=useState(true);
  const [recalcing,setRecalcing]=useState(false);
  const [hideBridge,setHideBridge]=useState(()=>localStorage.getItem('admin_hide_bridge_tab')==='true');
  const [accessChecked,setAccessChecked]=useState(false);
  const [isPartnerAdmin,setIsPartnerAdmin]=useState(false);
  const [isCrunchAlphaAdmin,setIsCrunchAlphaAdmin]=useState(false);
  const [partnerConfig,setPartnerConfig]=useState(null);
  const [partnerProviders,setPartnerProviders]=useState([]);
  const [partnerFeeRules,setPartnerFeeRules]=useState([]);
  const [partnerUsers,setPartnerUsers]=useState([]);
  const [partnerTab,setPartnerTab]=useState(0);
  const [partnerOverview,setPartnerOverview]=useState(null);
  const [partnerAccounts,setPartnerAccounts]=useState([]);
  const [partnerSignalSets,setPartnerSignalSets]=useState([]);
  const toggleHideBridge=()=>{
    const next=!hideBridge;
    setHideBridge(next);
    localStorage.setItem('admin_hide_bridge_tab', next?'true':'false');
    if(next && activeTab===17){ setActiveTab(0); }
  };

  const loadAll=useCallback(async()=>{
    setLoading(true);
    try{
      const [s,u,a,ss,b,fo,al,cf,ssubs,csubs,gr,fc,at,cd,fr]=await Promise.all([
        adminAPI.getStats(),adminAPI.getUsers(),adminAPI.getTradingAccounts(),
        adminAPI.getSignalSets(),adminAPI.getBrokers(),adminAPI.getFeeOverrides(),
        adminAPI.getAuditLogs(),adminAPI.getCashflowSummary(),
        adminAPI.getSignalSubscriptions(),adminAPI.getCopySubscriptions(),
        adminAPI.getUserGrowth(),
        adminAPI.getFeeConfig(),adminAPI.getAffiliateTiers(),adminAPI.getConfigDocs(),
        adminAPI.getFeeRules(),
      ]);
      setStats(s);setUsers(u.data||[]);setAccounts(a.data||[]);
      setSignalSets(ss.data||[]);setBrokers(b.data||[]);
      setOverrides(fo.data||[]);setAuditLogs(al.data||[]);
      setCashflow(cf);setSignalSubs(ssubs.data||[]);
      setCopySubs(csubs.data||[]);setGrowth(gr);setFeeConfig(fc.data||[]);setAffiliateTiers(at.data||[]);setConfigDocs(cd);setFeeRules(fr.data||[]);
    }catch(e){console.error(e);}
    setLoading(false);
  },[]);

  // Deteksi akses: CrunchAlpha admin (is_admin di localStorage, sama seperti
  // ProtectedRoute allowedRoles cek) vs partner admin (cek via 1 endpoint
  // partner-admin - kalau 403, bukan partner admin, coba fallback CrunchAlpha
  // admin biasa). Ini di-cek SEKALI di awal, SEBELUM loadAll dipanggil -
  // partner admin TIDAK PERNAH memanggil loadAll (yang isinya 15 fetch ke
  // /api/admin/* yang mereka tidak punya izin sama sekali).
  const loadPartnerData=useCallback(async()=>{
    setLoading(true);
    try{
      const [cfg,prov,fee,usr,ov,acc,ss]=await Promise.all([
        adminAPI.getPartnerAdminConfig(),
        adminAPI.getPartnerAdminProviders(),
        adminAPI.getPartnerAdminFeeRules(),
        adminAPI.getPartnerAdminUsers(),
        adminAPI.getPartnerAdminOverview(),
        adminAPI.getPartnerAdminAccounts(),
        adminAPI.getPartnerAdminSignalSets(),
      ]);
      setPartnerConfig(cfg.data||null);
      setPartnerProviders(prov.data||[]);
      setPartnerFeeRules(fee.data||[]);
      setPartnerUsers(usr.data||[]);
      setPartnerOverview(ov.data||null);
      setPartnerAccounts(acc.data||[]);
      setPartnerSignalSets(ss.data||[]);
    }catch(e){console.error(e);}
    setLoading(false);
  },[]);

  useEffect(()=>{
    const role=(localStorage.getItem("user_role")||"").toLowerCase();
    if(role==="admin"){
      setIsCrunchAlphaAdmin(true);
      setAccessChecked(true);
      return;
    }
    // Bukan role admin CrunchAlpha - cek apakah partner admin
    adminAPI.getPartnerAdminConfig().then(cfg=>{
      if(cfg.ok){
        setIsPartnerAdmin(true);
      }
      setAccessChecked(true);
    }).catch(()=>setAccessChecked(true));
  },[]);

  useEffect(()=>{
    if(!accessChecked) return;
    if(isCrunchAlphaAdmin){ loadAll(); }
    else if(isPartnerAdmin){ loadPartnerData(); }
    else{ setLoading(false); }
  },[accessChecked,isCrunchAlphaAdmin,isPartnerAdmin,loadAll,loadPartnerData]);

  const recalc=async()=>{
    setRecalcing(true);
    try{await adminAPI.recalcAlphaRank();alert("AlphaRank recalculated for all accounts");}
    catch(e){alert(e.message);}
    setRecalcing(false);
  };

  const reloadBrokers=async()=>{const r=await adminAPI.getBrokers();setBrokers(r.data||[]);};
  const reloadUsers=async()=>{const r=await adminAPI.getUsers();setUsers(r.data||[]);};
  const reloadOverrides=async()=>{const r=await adminAPI.getFeeOverrides();setOverrides(r.data||[]);};
  const reloadConfig=async()=>{const [fc,at]=await Promise.all([adminAPI.getFeeConfig(),adminAPI.getAffiliateTiers()]);setFeeConfig(fc.data||[]);setAffiliateTiers(at.data||[]);};
  const reloadFeeRules=async()=>{const r=await adminAPI.getFeeRules();setFeeRules(r.data||[]);};

  if(!accessChecked){
    return <div style={{textAlign:"center",padding:"80px 0",color:C.muted,fontSize:14}}>Loading...</div>;
  }

  if(isPartnerAdmin){
    const PARTNER_TABS=["Overview","Accounts","Signal Sets","Fee Report","Invoices","Withdrawals","Affiliates","Marketplace","Multi-Fee","Users","Registration","Members","Branding","Landing page"];
    const reloadPartnerConfig=async()=>{const r=await adminAPI.getPartnerAdminConfig();setPartnerConfig(r.data||null);};
    const reloadPartnerProviders=async()=>{const r=await adminAPI.getPartnerAdminProviders();setPartnerProviders(r.data||[]);};
    const reloadPartnerFeeRules=async()=>{const r=await adminAPI.getPartnerAdminFeeRules();setPartnerFeeRules(r.data||[]);};
    const partnerToggle=async(rule)=>{await adminAPI.updatePartnerAdminFeeRule(rule.fee_type_id,!rule.is_enabled,rule.params||{});};
    const partnerSaveParams=async(rule,parsed)=>{await adminAPI.updatePartnerAdminFeeRule(rule.fee_type_id,rule.is_enabled,parsed);};

    return (
      <div style={{padding:"24px 28px",maxWidth:1400,margin:"0 auto",background:C.bg,minHeight:"100vh"}}>
        <div style={{marginBottom:24}}>
          <h1 style={{fontSize:24,fontWeight:800,margin:0,color:C.text}}>Partner Admin</h1>
          <p style={{fontSize:13,color:C.muted,margin:"4px 0 0"}}>{partnerConfig?.displayName||""}</p>
        </div>
        <div style={{display:"flex",gap:0,marginBottom:20,borderBottom:`1px solid ${C.border}`}}>
          {PARTNER_TABS.map((t,i)=>(
            <button key={t} onClick={()=>setPartnerTab(i)} style={{padding:"8px 14px",fontSize:12,border:"none",background:"transparent",
              color:partnerTab===i?C.accent:C.muted,fontWeight:partnerTab===i?700:400,whiteSpace:"nowrap",
              borderBottom:partnerTab===i?`2px solid ${C.accent}`:"2px solid transparent",cursor:"pointer"}}>{t}</button>
          ))}
        </div>
        {loading?(
          <div style={{textAlign:"center",padding:"80px 0",color:C.muted,fontSize:14}}>Loading...</div>
        ):(
          <>
            {partnerTab===0&&<TabOverview partnerMode stats={partnerOverview?.stats||{}} cashflow={partnerOverview?.cashflow||{}} users={partnerOverview?.users||[]} accounts={partnerOverview?.accounts||[]} quota={partnerOverview?.quota}/>}
            {partnerTab===1&&<TabPartnerAccountsManager accounts={partnerAccounts} users={partnerUsers} reload={loadPartnerData}/>}
            {partnerTab===2&&<TabPartnerSignalSets sets={partnerSignalSets}/>}
            {partnerTab===3&&<TabPartnerFeeReport/>}
            {partnerTab===4&&<TabPartnerInvoices/>}
            {partnerTab===5&&<TabPartnerWithdrawals/>}
            {partnerTab===6&&<TabPartnerAffiliates/>}
            {partnerTab===7&&<TabPartnerMarketplace config={partnerConfig} providers={partnerProviders} reloadConfig={reloadPartnerConfig} reloadProviders={reloadPartnerProviders}/>}
            {partnerTab===8&&<TabMultiFee feeRules={partnerFeeRules} reload={reloadPartnerFeeRules} onToggle={partnerToggle} onSaveParams={partnerSaveParams}/>}
            {partnerTab===9&&<TabPartnerUsers users={partnerUsers}/>}
            {partnerTab===10&&<PartnerSignupTab/>}
            {partnerTab===11&&<PartnerMembersTab/>}
            {partnerTab===12&&<PartnerBrandingTab/>}
            {partnerTab===13&&<PartnerLandingTab/>}
          </>
        )}
      </div>
    );
  }

  if(!isCrunchAlphaAdmin){
    return (
      <div style={{padding:"40px",color:C.text}}>
        <h2 style={{color:C.danger}}>Access Denied</h2>
        <p style={{color:C.muted}}>Admin access required.</p>
      </div>
    );
  }

  return (
    <div style={{padding:"24px 28px",maxWidth:1400,margin:"0 auto",background:C.bg,minHeight:"100vh"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:24}}>
        <div>
          <h1 style={{fontSize:24,fontWeight:800,margin:0,color:C.text}}>Platform admin</h1>
          <p style={{fontSize:13,color:C.muted,margin:"4px 0 0"}}>Manage users, brokers, fees & platform health</p>
        </div>
        <div style={{display:"flex",gap:8}}>
          <Btn onClick={recalc} disabled={recalcing}>{recalcing?"Recalculating...":"Recalc AlphaRank"}</Btn>
          <Btn onClick={toggleHideBridge}>{hideBridge?"Show Bridge Tab":"Hide Bridge Tab"}</Btn>
          <Btn primary onClick={loadAll}>Refresh</Btn>
        </div>
      </div>

      <div style={{display:"flex",gap:0,marginBottom:20,borderBottom:`1px solid ${C.border}`,overflowX:"auto",WebkitOverflowScrolling:"touch",scrollbarWidth:"thin",msOverflowStyle:"auto",flexShrink:0,minWidth:0}}>
        {TABS.map((t,i)=>(
          (t==="Bridge" && hideBridge) ? null : (
          <button key={t} onClick={()=>setActiveTab(i)} style={{padding:"8px 14px",fontSize:12,border:"none",background:"transparent",
            color:activeTab===i?C.accent:C.muted,fontWeight:activeTab===i?700:400,whiteSpace:"nowrap",
            borderBottom:activeTab===i?`2px solid ${C.accent}`:"2px solid transparent",cursor:"pointer"}}>{t}</button>
          )
        ))}
      </div>

      {loading?(
        <div style={{textAlign:"center",padding:"80px 0",color:C.muted,fontSize:14}}>Loading...</div>
      ):(
        <>
          {activeTab===0&&<TabOverview stats={stats} cashflow={cashflow} users={users} accounts={accounts}/>}
          {activeTab===1&&<TabUsers users={users} reload={reloadUsers}/>}
          {activeTab===2&&<TabAccounts accounts={accounts} brokers={brokers} users={users} token={localStorage.getItem("access_token")||localStorage.getItem("token")||""} reload={async()=>{const r=await adminAPI.getTradingAccounts();setAccounts(r.data||[]);}}/>}
          {activeTab===3&&<TabSignalSets sets={signalSets} users={users} token={localStorage.getItem("access_token")||localStorage.getItem("token")||""}/>}
          {activeTab===4&&<TabBrokers brokers={brokers} reload={reloadBrokers}/>}
          {activeTab===5&&<TabCashflow cashflow={cashflow} signalSubs={signalSubs} copySubs={copySubs}/>}
          {activeTab===6&&<TabUserGrowth growth={growth} cashflow={cashflow}/>}
          {activeTab===7&&<TabFeeReport brokers={brokers} reloadAccounts={async()=>{const r=await adminAPI.getTradingAccounts();setAccounts(r.data||[]);}}/>}
          {activeTab===8&&<TabFees overrides={overrides} reload={reloadOverrides}/>}
          {activeTab===9&&<TabPlatformConfig feeConfig={feeConfig} affiliateTiers={affiliateTiers} docs={configDocs} reloadConfig={reloadConfig}/>}
          {activeTab===10&&<TabAuditLogs/>}
          {activeTab===11&&<TabAffiliates/>}
          {activeTab===12&&<TabSubscriptions token={localStorage.getItem("access_token")||localStorage.getItem("token")||""}/>}
          {activeTab===13&&<TabPayments token={localStorage.getItem("access_token")||localStorage.getItem("token")||""}/>}
          {activeTab===14&&<TabWithdrawals token={localStorage.getItem("access_token")||localStorage.getItem("token")||""}/>}
          {activeTab===15&&<AdminInvoices/>}
          {activeTab===16&&<div style={{padding:"24px 0"}}><BannerControl/></div>}
          {activeTab===17&&<TabBridge/>}
          {activeTab===18&&<TabMultiFee feeRules={feeRules} reload={reloadFeeRules}/>}
          {activeTab===19&&<TabPartners/>}
        </>
      )}
    </div>
  );
};

export default AdminDashboard;
